import React, { Component, Fragment } from "react";
import "react-select/dist/react-select.css";
import $ from "jquery";
import printer from "../../assets/images/printer.png";
import PrintSample from "../../components/printSample";
import Audit from "../../components/Common/audit";
import html2canvas from "html2canvas";
import Button from "../../components/Buttons/Button";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
// import { convertFromHTML } from 'draft-js';

//services
import {
  MeetingNotesServices,
  DevelopmentServices,
  SampleServices,
  UtilityService,
  CostingServices,
  CustomerServices,
  StyleServices,
  PermissionServices,
} from "../../services";

//components
import {
  CadModule,
  CostingModule,
  CuttingModule,
  DispatchModule,
  EmbellishmentModule,
  EmbroideryModule,
  FabricModule,
  GarmentTechModule,
  LeftSection,
  MarkerModule,
  PatternModule,
  ProcessUpdate,
  QcModule,
  SampleMain,
  SampleModule,
  SampleModuleSelect,
  ScrollMenu,
  SewingModule,
  SignOffModule,
  TrimModule,
  WashModule,
} from "../../components/SampleRequest";
import Loading from "../../components/Common/Loading";
import PageHeader from "../../components/Page/PageHeader/PageHeader";

//redux
import { connect } from "react-redux";
import PrintGarmentTech from "../../components/SampleRequest/GarmentTechModule/PrintGarmentTech";
const allProceses = [
  "sample",
  "cad",
  "fabric",
  "trim",
  "pattern",
  "cutting",
  "sewing",
  "embellishment",
  "embroidery",
  "marker",
  "costing",
  "signOff",
  "dispatch",
  "garmentTechnologist",
  "qc",
  "wash",
];
class Sample extends Component {
  state = {
    styleNoInfo: [],
    action: "",
    comments: "",
    _id: "",
    emptyData: null,
    selected: "sampleRequest",
    measurementChartData: {},
    sampleRequest: {
      requestNumber: null,
      qr: "",
      selectedType: "sampleRequest",
      originationOfRequest: null,
      magnumStyleId: null,
      typeOfRequest: "",
      sampleType: null,
      requiredDate: null,
      buyerName: "",
      assistantBuyer: "",
      fabricTechnologist: "",
      garmentTechnology: "",
      magnumTechnologist: null,
      customer: null,
      customerDepartmentId: null,
      orderDate: new Date(),
      styleReferenceId: null,
      magnumStyleName: "",
      customerRefNumber: "",
      test1: null,
      test2: "dsd",
      sample: {
        awaitingDevSample: false,
        awaitingDevSheet: false,
        data: [
          {
            size: null,
            quantity: null,
          },
        ],
        comments: "",
      },
      cad: {
        cadId: null,
        cadName: "",
        cadRefNo: "",
        cadType: [],
        comments: "",
      },
      fabric: [],

      fabricRadio: "notInHse",
      trimRadio: "notInHse",
      trim: {
        // row1: [
        //   {
        //     trimId: null,
        //     trimCategory: null,
        //     trimNumber: null,
        //     description: "",
        //     size: "",
        //     quality: "",
        //     sizeNumber: "",
        //     trimRadio: "notInHse"
        //   }
        // ],
        smokingOrShiring: false,
        // row2: [
        //   {
        //     trimCategory: null,
        //     trimNumber: null,
        //     placement: null,
        //     number: null,
        //     type: null,
        //     noOfRow: null,
        //     length: null,
        //     totalReq: null
        //   }
        // ],
        comment: "",
      },
      pattern: {
        patternMaster: null,
        patternType: null,
        blockRefNumber: "",
        trailRequired: false,
        comment: "",
        date: null,
        existingBlockRefNumber: "",
        followedBlockRequired: false,
        approvalStatus: "",
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: "",
          },
        ],
      },

      cutting: {
        cuttingMasterName: null,
        cuttingType: null,
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: "",
          },
        ],
        comments: "",
        patternIssues: "",
        fabricIssues: false,
        approvalStatus: "",
      },
      sewing: {
        placeOfSewing: "5cde88716510d24851321273",
        sewingData: [
          {
            tailorName: null,
            sewingType: "5cde887e6510d24851321276",
            size: "",
            quantity: "",
            approvalStatus: "",
            rejected: "",
            logs: [
              // {
              //   remarks: "",
              //   timeIn: "",
              //   timeOut: "",
              //   breakTime: "",
              //   reason: ""
              // }
            ],
          },
        ],
        smokingOrShiring: false,
        trimData: [
          {
            trimCategory: null,
            trimNumber: null,
            placement: null,
            number: null,
            type: null,
            noOfRow: null,
            length: null,
            totalReq: null,
          },
        ],

        comments: "",
      },
      embellishment: [
        {
          embType: null,
          hoursMinutes: null,
          pricePerHalfHour: null,
        },
      ],
      embellishmentComments: "",
      embroidery: {
        cutPanel: false,
        allOver: false,
        garmentForm: false,
        semiGarmentForm: false,
        tassel: false,
        selected: [String],
        rightData: [],
        leftData: [],
        additionalInfo: "",
        refImages: [],
        employeeName: null,
        smocking: false,
        sheering: false,
        backing: false,
        bitAttaching: false,
        backingData: [
          {
            backingType: null,
            width: null,
            placement: null,
          },
        ],
        embroideryData: [
          {
            embPlacement: null,
            embForm: null,
            noOfCols: null,
            frames: null,
            stitchesMtr: "",
            consumption: "",
            stitchCount: "",
            priceForStitches: "",
          },
        ],
        machine: [
          {
            frames: null,
            forms: null,
            placement: null,
            noOfCols: null,
            stitches: null,
            consumptions: null,
            StitchCount: null,
            price: null,
            backing: [
              {
                backing: "",
                width: null,
                placement: null,
              },
            ],
          },
        ],
        comments: "",
      },
      garmentTechnologist: {
        // sampleForm: [
        //   {
        //     comments: "",
        //     fab: false,
        //     trims: false,
        //     workManShip: false,
        //     buyerChanges: false,
        //     pat: false,
        //     remarks: ""
        //   }
        // ],
        sampleForm: {
          fitMesurements: [],
          makeupConstruction: [],
          trimsComponents: [],
          packPresentation: [],
        },
        garmentTechComments: "",
        markerRequirements: false,
        smvAmmendment: false,
        trailRequired: false,
        mock: false,
        comment: "",
      },
      wash: {
        washData: {
          washType: null,
          washFrom: "5d8c601cdd0f0307127f3770",
          laundryUnit: null,
          price: null,
        },
        hasMock: false,
        numberOfMocks: null,
        tacking: false,
        recipe: true,
        refImages: [],
        comments: "",
      },
      dispatch: {
        magnumCounter: false,
        data: [
          // {
          //   location: null,
          //   date: null,
          //   courier: null,
          //   awbNumber: "",
          //   size: null,
          //   quantity: null
          // }
        ],
        comments: "",
        magnum: false,
      },
      qc: {
        anyIssue: false,
        reason: "",
        refImages: [],
        comments: "",
        remarks: "",
      },
      marker: {
        refImages: [],
        comments: "",
      },
      costingComments: "",
      signOffComments: "",
      processUpdates: {
        sample: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        garmentTechnologist: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        cad: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        fabric: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        trim: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        pattern: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        cutting: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        sewing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        embellishment: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        embroidery: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        wash: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        dispatch: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        qc: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        marker: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        costing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },
        signOff: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },
      },
      printLoading: false,
      fabricComments: "",
      toggle: {
        sample: true,
        cad: false,
        fabric: true,
        trim: true,
        pattern: true,
        cutting: true,
        sewing: true,
        garmentTechnologist: true,
        embellishment: false,
        embroidery: false,
        wash: false,
        dispatch: true,
        qc: true,
        marker: true,
        costing: true,
        signOff: true,
      },
    },

    prefillInfo: {
      SAMPLEREQUEST: {},
      SAMPLE: {},
      CAD: {},
      FABRIC: {},
      TRIM: {},
      PATTERNTYPE: [],
      CUTTINGTYPE: [],
      STATUS: {},
      SEWING: {},
      SYSTEMSAMPLEREQUEST: {},
      EMBROIDERY: {},
      WASH: {},
      CUTTINGMASTER: [],
      PATTERNMASTER: [],
    },
    isLoading: false,
    default: false,
    printGarmentLoading: false,
    printGarmentTech: {},

    assignedToList: [],
    sizeList: [],
    assignedTo: {},
    row1List: [],
    row2List: [],
    rights: {},
    widthList: [],
    sampleMain: {},
    fabricList: [],
    customerDepartment: {},
    duplicateData: {
      processUpdates: {
        sample: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        garmentTechnologist: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        cad: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        fabric: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        trim: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        pattern: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        cutting: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        sewing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        embellishment: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        embroidery: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        wash: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        dispatch: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        qc: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        marker: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },

        costing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },
        signOff: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: null,
          processCompleted: false,
          processDate: null,
          comments: "",
        },
      },
      sample: {
        awaitingDevSample: false,
        awaitingDevSheet: false,
        data: [],
        sizes: [],
        comments: "",
      },
      cad: {
        cadId: null,
        cadName: "",
        cadRefNo: "",
        cadType: [],
        comments: "",
      },
      fabricRadio: "notInHse",
      trimRadio: "notInHse",
      pattern: {
        patternMaster: null,
        patternType: null,
        blockRefNumber: "",
        trailRequired: false,
        comment: "",
        date: null,
        existingBlockRefNumber: "",
        followedBlockRequired: false,
        approvalStatus: "",
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: "",
          },
        ],
      },

      cutting: {
        cuttingMasterName: null,
        cuttingType: null,
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: "",
          },
        ],
        comments: "",
        patternIssues: "",
        fabricIssues: false,
        approvalStatus: "",
      },
      sewing: {
        placeOfSewing: "5cde88716510d24851321273",
        sewingData: [
          {
            tailorName: null,
            sewingType: "5cde887e6510d24851321276",
            size: "",
            quantity: "",
            approvalStatus: "",
            rejected: "",
            logs: [
              // {
              //   remarks: "",
              //   timeIn: "",
              //   timeOut: "",
              //   breakTime: "",
              //   reason: ""
              // }
            ],
          },
        ],
        smokingOrShiring: false,
        trimData: [
          {
            trimCategory: null,
            trimNumber: null,
            placement: null,
            number: null,
            type: null,
            noOfRow: null,
            length: null,
            totalReq: null,
          },
        ],

        comments: "",
      },
      embellishment: [
        {
          embType: null,
          hoursMinutes: null,
          pricePerHalfHour: null,
        },
      ],
      embellishmentComments: "",
      embroidery: {
        cutPanel: false,
        allOver: false,
        garmentForm: false,
        semiGarmentForm: false,
        tassel: false,
        selected: [String],
        rightData: [],
        leftData: [],
        additionalInfo: "",
        refImages: [],
        employeeName: null,
        smocking: false,
        sheering: false,
        backing: false,
        bitAttaching: false,
        backingData: [
          {
            backingType: null,
            width: null,
            placement: null,
          },
        ],
        embroideryData: [
          {
            embPlacement: null,
            embForm: null,
            noOfCols: null,
            frames: null,
            stitchesMtr: "",
            consumption: "",
            stitchCount: "",
            priceForStitches: "",
          },
        ],
        machine: [
          {
            frames: null,
            forms: null,
            placement: null,
            noOfCols: null,
            stitches: null,
            consumptions: null,
            StitchCount: null,
            price: null,
            backing: [
              {
                backing: "",
                width: null,
                placement: null,
              },
            ],
          },
        ],
        comments: "",
      },
      garmentTechnologist: {
        sampleForm: {
          fitMesurements: [],
          makeupConstruction: [],
          trimsComponents: [],
          packPresentation: [],
        },
        garmentTechComments: "",
        markerRequirements: false,
        smvAmmendment: false,
        trailRequired: false,
        mock: false,
        comment: "",
      },
      dispatch: {
        magnumCounter: false,
        data: [
          // {
          //   location: null,
          //   date: null,
          //   courier: null,
          //   awbNumber: "",
          //   size: null,
          //   quantity: null
          // }
        ],
        comments: "",
        magnum: false,
      },
      qc: {
        anyIssue: false,
        reason: "",
        refImages: [],
        comments: "",
        remarks: "",
      },
      marker: {
        refImages: [],
        comments: "",
      },
    },
  };

  componentWillUnmount() {
    if (this.state.action === "add")
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww";
      });
  }

  onEditorStateChange = (value, arrKey, arrSubKey, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let locateDraft = sampleRequest.garmentTechnologist.sampleForm;
    let index = -1;
    let subindex = 0;
    for (var key in locateDraft) {
      index++;
      if (locateDraft.hasOwnProperty(key)) {
        if (key === arrKey) {
          locateDraft[key].forEach((element) => {
            if (key.toString() + subindex === arrSubKey) {
              element.comments = value;
            }
            subindex++;
          });
        }
        this.setState({
          sampleRequest,
        });
      }
    }
  };

  waitForStateToUpdate = () => {
    return new Promise((resolve) => {
      const checkState = () => {
        if (
          this.state.sampleRequest.customer &&
          this.state.sampleRequest.customerDepartmentId
        ) {
          resolve(); // Resolve the promise if the state is correct
        } else {
          setTimeout(checkState, 50); // Check again after a short delay
        }
      };
      checkState();
    });
  };

  async componentWillMount() {
    await this.setState({
      isLoading: true,
    });
    let action, _id, referenceId, styleId, setStyleId;
    if (this.props.location.state) {
      action = this.props.location.state.action;
      _id = this.props.location.state._id;
      referenceId = this.props.location.state.referenceId;
      styleId = this.props.location.state.styleId;
      setStyleId = this.props.location.state.setStyleId;
    } else {
      const urlParams = new URLSearchParams(this.props.location.search);
      action = urlParams.get("action");
      _id = urlParams.get("_id");
      let hash = this.props.location.hash.split("#")[1];
      this.props.history.replace("/Sample", {
        action,
        _id,
        hash,
      });
    }
    if (
      styleId != "" &&
      referenceId != "" &&
      styleId !== undefined &&
      referenceId !== undefined
    ) {
      let sampleRequest = { ...this.state.sampleRequest };
      //console.log(sampleRequest,"sampleRequest");
      sampleRequest.magnumStyleId = styleId;
      sampleRequest.styleReferenceId = referenceId;
      if (setStyleId) {
        await this.getMagnumStyleById(sampleRequest.styleReferenceId);
      }
      await this.setState(
        {
          sampleRequest,
        },
        () =>
          this.getStyleReferenceInfo(this.state.sampleRequest.styleReferenceId),
      );
    }

    await this.setState({
      action,
      _id,
    });

    if (action == "add") {
      //getting qr and request no. while adding
      // this.setState({
      //   isLoading: true
      // });
      await SampleServices.getSampleQr()
        .then((response) => {
          if (response.status === 200) {
            //console.log(response,"res3")
            let sampleRequest = { ...this.state.sampleRequest };
            //console.log(this.state.sampleRequest, "sampleRequest6");
            sampleRequest.qr = response.text.data.qr;
            sampleRequest.requestNumber = response.text.data.requestNumber;
            // Object.keys(sampleRequest.processUpdates).forEach(keyname => {
            //   sampleRequest.processUpdates[keyname].status = "PENDING"
            //   sampleRequest.processUpdates[keyname].ETA = new Date()
            // })
            this.setState({
              sampleRequest,
              // isLoading: false
            });
          }
          response.status === 401 && this.props.unauthorisedFunc();
        })
        .catch((err) => {
          this.props.getalertMessage("error");
        });
      if (setStyleId) {
        await this.getMagnumStyleById(styleId);
      } else {
        await this.getMagnumStyleNo("");
      }
    }

    if (action == "view") {
      await this.setState({
        disabled: true,
      });
    }

    if (action == "edit" || action == "view") {
      if (_id !== "") {
        await SampleServices.SampleInfo(_id).then((response) => {
          if (response.status == 200) {
            this.setState({ sampleRequest: response.text.data });
            let sampleRequest = { ...this.state.sampleRequest };

            if (response.text.data.sample.data.length === 0) {
              sampleRequest.sample.data = [
                {
                  size: null,
                  quantity: null,
                },
              ];
            }

            if (
              response.text.data.garmentTechnologist.sampleForm.length === 0
            ) {
              sampleRequest.garmentTechnologist.sampleForm = [
                {
                  comments: "",
                  fab: false,
                  trims: false,
                  workManShip: false,
                  buyerChanges: false,
                  pat: false,
                  remarks: "",
                },
              ];
            }

            if (response.text.data.pattern.logs.length === 0) {
              sampleRequest.pattern.logs = [
                {
                  remarks: "",
                  timeIn: "",
                  timeOut: "",
                  breakTime: "",
                  reason: "",
                },
              ];
            }

            if (response.text.data.cutting.logs.length === 0) {
              sampleRequest.cutting.logs = [
                {
                  remarks: "",
                  timeIn: "",
                  timeOut: "",
                  breakTime: "",
                  reason: "",
                },
              ];
            }

            sampleRequest.processUpdates = {
              ...response.text.data.processUpdates,
            };

            this.getMagnumStyleById(sampleRequest.styleReferenceId);
            this.setState(
              {
                sampleRequest,
                _id: response.text.data._id,
                createdAt: response.text.data.createdAt,
              },
              () => {
                //this.getAssignedTo()
                this.getStyleReferenceInfo(
                  this.state.sampleRequest.styleReferenceId,
                );
              },
            );
          }
        });
      }
      setTimeout(() => {
        if (
          this.props.history.location &&
          this.props.history.location.state &&
          this.props.history.location.state.hash
        ) {
          let hash =
            this.props.history.location.state.hash === "GARMENT TECH"
              ? "garmentTechnologist"
              : "SIGN OFF" === this.props.history.location.state.hash
                ? "signOff"
                : this.props.history.location.state.hash.toLowerCase();
          this.scrollToModule(hash);
        }
      }, 500);
    }

    //magnumStyleId
    // this.getMagnumStyleNo("");

    let sampleRequestType = window.location.href.split("/")[3].split("?")[1];

    if (sampleRequestType === "reference") {
      let objData = {};
      ((objData.label = localStorage.getItem("referenceCode")),
        (objData.value = localStorage.getItem("styleId")));
      objData.customerId = localStorage.getItem("customerId");
      objData.customerDepartmentId = localStorage.getItem("departmentId");
      objData.referenceId = localStorage.getItem("referenceId");

      this.setState({ styleNo: objData }, function () {});
    } else if (
      window.location.href.split("/")[3].split("?")[1] === "MNId=true" ||
      window.location.href.split("/")[3].split("?")[1] === "fromCAD=true"
    ) {
      let styleData = JSON.parse(localStorage.getItem("styleInfoForSample"));
      CostingServices.getRequestInfoByStyleId(styleData.value)
        .then((response) => {
          if (response.message === "Sample Request Data") {
            let objData = {};
            ((objData.label = styleData.label),
              (objData.value = styleData.value));
            ((objData.customerId = styleData.customerId),
              (objData.customerDepartmentId = styleData.customerDepartmentId));
            objData.referenceId = styleData.styleReferenceId;

            this.setState({ styleNo: objData });
          }
        })
        .catch((error) => {
          alert("Something Went Wrong...Try Again Later");
        });
    }

    await SampleServices.prefillSRDetails()
      .then((response) => {
        if (response.message === "Operation Successful") {
          let sampleRequest = { ...this.state.sampleRequest };

          sampleRequest.embroidery.leftData = [
            ...response.data.SYSTEMSAMPLEREQUEST.LEFTVALUES,
          ];
          this.setState({
            sampleRequest,
            sampleRequestType,
            prefillInfo: response.data,
            styleInfo: response.data.Style,
            fabricInfo: response.data.Fabric,
            trimInfo: response.data.Trims,
          });

          if (action === "add") {
            let prefillInfo = this.state.prefillInfo;
            // Trim Category for Trim Module
            // let trimCategory =
            //   prefillInfo.TRIM.TRIMCATEGORY &&
            //   prefillInfo.TRIM.TRIMCATEGORY.filter(
            //     x => x.label.toLowerCase() === "thread"
            //   )[0]
            // Trim Category for Sewing Module
            let trimCategorySewing =
              prefillInfo.TRIM.TRIMCATEGORY &&
              prefillInfo.TRIM.TRIMCATEGORY.filter(
                (x) => x.label.toUpperCase() === "THREAD ELASTIC",
              )[0];
            // sampleRequest.trim.row1[0].trimCategory =
            //   trimCategory && trimCategory.value
            // sampleRequest.trim.row2[0].trimCategory =
            //   trimCategory && trimCategory.value
            sampleRequest.sewing.trimData[0].trimCategory =
              trimCategorySewing && trimCategorySewing.value;
            // if (
            //   sampleRequest.trim &&
            //   sampleRequest.trim.row1 &&
            //   sampleRequest.trim.row1.length > 0
            // ) {
            //   sampleRequest.trim.row1.forEach((x, i) => {
            //     if (x.trimCategory) {
            //       SampleServices.getTrimNumber(x.trimCategory)
            //         .then(async response => {
            //           sampleRequest.trim.row1[i].trimList = response.text.data
            //         })
            //         .catch(error => alert(error.toString()))
            //     }
            //   })
            // }

            // if (
            //   sampleRequest.trim &&
            //   sampleRequest.trim.row2 &&
            //   sampleRequest.trim.row2.length > 0
            // ) {
            //   sampleRequest.trim.row2.forEach((x, i) => {
            //     if (x.trimCategory) {
            //       SampleServices.getTrimNumber(x.trimCategory)
            //         .then(async response => {
            //           sampleRequest.trim.row2[i].trimList = response.text.data
            //         })
            //         .catch(error => alert(error.toString()))
            //     }
            //   })
            // }

            this.setState({ sampleRequest });

            sampleRequest.wash.washData.price = null;
          } else if (action === "edit") {
            let prefillInfo = this.state.prefillInfo;
            // Trim Category for Trim Module
            let trimCategory =
              prefillInfo.TRIM.TRIMCATEGORY &&
              prefillInfo.TRIM.TRIMCATEGORY.filter(
                (x) => x.label.toLowerCase() === "thread",
              )[0].value;
            // Trim Category for Sewing Module
            let trimCategorySewing =
              prefillInfo.TRIM.TRIMCATEGORY &&
              prefillInfo.TRIM.TRIMCATEGORY.filter(
                (x) => x.label.toUpperCase() === "THREAD ELASTIC",
              )[0];
            // sampleRequest.trim.row1 = sampleRequest.trim.row1.map(x => {
            //   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
            //   return x
            // })
            // sampleRequest.trim.row2 = sampleRequest.trim.row2.map(x => {
            //   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
            //   return x
            // })
            sampleRequest.sewing.trimData = sampleRequest.sewing.trimData.map(
              (x) => {
                x.trimCategory = x.trimCategory
                  ? x.trimCategory
                  : trimCategorySewing;
                return x;
              },
            );
            // if (
            //   sampleRequest.trim &&
            //   sampleRequest.trim.row1 &&
            //   sampleRequest.trim.row1.length > 0
            // ) {
            //   sampleRequest.trim.row1.forEach((x, i) => {
            //     if (x.trimCategory) {
            //       SampleServices.getTrimNumber(x.trimCategory)
            //         .then(async response => {
            //           sampleRequest.trim.row1[i].trimList = response.text.data
            //         })
            //         .catch(error => alert(error.toString()))
            //     }
            //   })
            // }

            if (
              sampleRequest.sewing &&
              sampleRequest.sewing.trimData &&
              sampleRequest.sewing.trimData.length
            ) {
              sampleRequest.sewing.trimData.forEach((x, i) => {
                if (x.trimCategory) {
                  SampleServices.getTrimNumber(x.trimCategory)
                    .then(async (response) => {
                      sampleRequest.sewing.trimData[i].trimList =
                        response.text.data;
                    })
                    .catch((error) => alert(error.toString()));
                }
              });
            }

            // if (
            //   sampleRequest.trim &&
            //   sampleRequest.trim.row2 &&
            //   sampleRequest.trim.row2.length > 0
            // ) {
            //   sampleRequest.trim.row2.forEach((x, i) => {
            //     if (x.trimCategory) {
            //       SampleServices.getTrimNumber(x.trimCategory)
            //         .then(async response => {
            //           sampleRequest.trim.row2[i].trimList = response.text.data
            //         })
            //         .catch(error => alert(error.toString()))
            //     }
            //   })
            // }

            // sampleRequest.wash.washData[0].price =
            //   prefillInfo.WASH.PRICEPERKG[0].label
            // sampleRequest.wash.washData = sampleRequest.wash.washData.map((x)=>{
            //   x.price = x.price ? x.price : prefillInfo.WASH.PRICEPERKG[0].label
            // })
            // this.setState({ sampleRequest })
          }
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
    await CustomerServices.customerInfo()
      .then((response) => {
        if (response.message === "all customer details") {
          this.setState({
            customerList: response.data,
            // customerId: response.data[0]._id,
            // departmentId: response.data[0].departmentId
          });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });

    // await this.getAssignToList("")

    // await  this.setState({
    //     rights: this.props.rights
    //   });
    let copyOfSamplerequest = JSON.stringify(this.state.sampleRequest);

    await this.setState({
      isLoading: false,
      emptyData: copyOfSamplerequest,
    });
    await this.getAssignToList();
    if (this.state.action === "edit" || this.state.action === "add") {
      if (this.state.action !== "add") await this.waitForStateToUpdate();
      await SampleServices.getCustomerData({
        customer: this.state.sampleRequest.customer,
        customerDepartmentId: this.state.sampleRequest.customerDepartmentId,
        type: this.state.sampleRequest.typeOfRequest,
      })
        .then((response) => {
          if (response.status == 200) {
            this.setState({
              sizeList: response.text.data.sizes,
            });
          }
        })
        .catch((error) =>
          this.props.getalertMessage("error hell", error.toString()),
        );
    }
  }

  componentDidMount() {
    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww";
      });
    }
    if (this.props.history.location.state) {
      if (this.props.history.location.state.sample) {
        this.setState({
          ...this.props.history.location.state.sample,
        });
      }
    }
    DevelopmentServices.getFabricNumber("")
      .then((response) => {
        if (response.status == 200) {
          this.setState({ fabricList: response.text.data });
        }
      })
      .catch((error) => {});
    CustomerServices.customerInfo()
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            customerList: response.text.data,
            // customerId: response.data[0]._id,
            // departmentId: response.data[0].departmentId
          });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });

    DevelopmentServices.prefillDataCadSystem().then((res) => {
      if (res.status === 200) {
        this.setState({
          cadPreFill: {
            CADTYPE: res.text.data.CADTYPE,
            PRINTEMBTYPE: res.text.data.PRINTEMBTYPE,
            BORDERTYPE: res.text.data.BORDERTYPE,
          },
        });
      }
    });
  }

  //Assinedto all modules
  getAssignedTo = () => {
    SampleServices.getCustomerData({
      customer: this.state.sampleRequest.customer,
      customerDepartmentId: this.state.sampleRequest.customerDepartmentId,
      type: this.state.sampleRequest.typeOfRequest,
    })
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.text.data.assignedTo).length > 0) {
            let sampleRequest = { ...this.state.sampleRequest };
            let assignmentOfwork = [
              "sample",
              "cad",
              "fabric",
              "pattern",
              "cutting",
              "sewing",
              "trim",
              "garmentTechnologist",
              "embellishment",
              "embroidery",
              "wash",
              "dispatch",
              "qc",
              "marker",
              "costing",
              "signOff",
            ];
            assignmentOfwork.map((keyName) => {
              sampleRequest.processUpdates[keyName].assignedTo =
                response.text.data.assignedTo[keyName] !== null
                  ? response.text.data.assignedTo[keyName].value
                  : null;
            });
            this.setState({
              sampleRequest,
            });
          }
          this.setState({
            sizeList: response.text.data.sizes,
          });
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeAllHandler = (status) => {
    if (this.state._id !== "") {
      const completedProcess = { ...this.state.sampleRequest.processUpdates };
      for (let i in completedProcess) {
        completedProcess[i].status = status;
        if (status === "COMPLETED") {
          completedProcess[i].processDate = new Date();
        }
      }
      this.setState({
        sampleRequest: {
          ...this.state.sampleRequest,
          processUpdaes: completedProcess,
        },
      });
      let sampleRequestData = this.state.sampleRequest;
      sampleRequestData._id = this.state._id;

      Object.keys(sampleRequestData).forEach((x) => {
        if (allProceses.includes(x)) {
          delete sampleRequestData[x];
        }
      });
      SampleServices.createSampleRequest(sampleRequestData)
        .then((res) => {
          if (res.status === 200) {
            this.props.getalertMessage("success", res.text.message);
            this.setState(
              {
                _id: res.text.data._id,
              },
              () => this.getAssignedTo(),
            );
          } else {
            let required = [
              "originationOfRequest",
              "magnumStyleId",
              "typeOfRequest",
              "sampleType",
              "buyerName",
              "assistantBuyer",
            ].filter((x) => {
              if (
                this.state.sampleRequest[x] === "" ||
                this.state.sampleRequest[x] === undefined ||
                this.state.sampleRequest[x] === null
              ) {
                return x;
              }
            });
            this.props.getalertMessage("info", `${required[0]} Required`);
          }
          res.status === 401 && this.props.unauthorisedFunc();
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString()),
        );
    } else {
      this.props.getalertMessage("error", "Need to create sample request!.");
    }
  };

  getMainValues = async (customer, customerDepartmentId) => {
    if (customer == null || customerDepartmentId == null) {
      let sample = this.state.sampleRequest;
      sample.styleReferenceId = null;
      this.setState({
        sampleRequest: sample,
        isLoading: false,
      });
      this.props.getalertMessage(
        "error",
        "Selected Magnum Styleref have invalid data",
      );
    }

    await SampleServices.getCustomerData2({
      customer: customer,
      customerDepartmentId: customerDepartmentId,
    })
      .then(async (response) => {
        if (response.status == 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.assistantBuyer = response.text.data.asstbuyer;
          sampleRequest.buyerName = response.text.data.buyer;
          sampleRequest.fabricTechnologist = response.text.data.fabtech;
          sampleRequest.garmentTechnology = response.text.data.gmttech;
          sampleRequest.magnumTechnologist =
            response.text.data.garmentTechnologist;
          this.setState({
            sampleRequest,
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        this.props.getalertMessage("error", error.toString());
      });
  };

  getMagnumStyleNo = (value) => {
    DevelopmentServices.getMagnumStyleNoWithReference(value)
      .then((response) => {
        if (response.status === 200) {
          let jsonData = [];
          response.text.data.map((info, index) => {
            let objData = {};
            objData.label = info.referenceCode;
            objData.value = info.referenceId;
            jsonData.push(objData);
          });
          this.setState({ styleNoInfo: jsonData });
        }
      })
      .catch((error) => {});
    //console.log(this.state.styleNoInfo.map(va=>va.label),"styleInf")
  };

  getMagnumStyleById = (value) => {
    DevelopmentServices.getMagnumStyleNoWithReferenceById(value)
      .then((response) => {
        if (response.status === 200) {
          this.setState({ styleNoInfo: response.text.data });
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  createSample = () => {
    let sampleRequestData = Object.assign({}, this.state.sampleRequest);

    const today = moment().format("DD MMM YYYY");
    sampleRequestData.processUpdates = Object.keys(
      sampleRequestData.processUpdates,
    ).reduce((processUpdates, processName) => {
      const eta = sampleRequestData.processUpdates[processName].ETA;
      processUpdates[processName] = {
        ...sampleRequestData.processUpdates[processName],
        ETA: eta ? moment(eta).format("DD MMM YYYY") : today,
      };
      return processUpdates;
    }, {});

    Object.keys(sampleRequestData).forEach((x) => {
      if (allProceses.includes(x)) {
        delete sampleRequestData[x];
      }
    });

    sampleRequestData.requiredDate = new Date();

    if (this.state._id !== "") {
      sampleRequestData._id = this.state._id;
    } else {
      delete sampleRequestData._id;
    }
    SampleServices.createSampleRequest(sampleRequestData)
      .then((res) => {
        if (res.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.qr = res.text.data.qr;
          sampleRequest.requestNumber = res.text.data.requestNumber;
          sampleRequest.createdAt = res.text.data.createdAt;

          this.props.getalertMessage("success", res.text.message);

          this.props.history.replace("/Sample", {
            action: "edit",
            _id: res.text.data._id,
          });
          this.setState(
            {
              _id: res.text.data._id,
              createdAt: res.text.data.createdAt,
              sampleRequest,
            },
            () => this.getAssignedTo(),
          );
        } else {
          let required = [
            "originationOfRequest",
            "magnumStyleId",
            "typeOfRequest",
            "sampleType",
            "buyerName",
            "assistantBuyer",
          ].filter((x) => {
            if (
              this.state.sampleRequest[x] === "" ||
              this.state.sampleRequest[x] === undefined ||
              this.state.sampleRequest[x] === null
            ) {
              return x;
            }
          });
          this.props.getalertMessage("info", `${required[0]} Required`);
        }
        res.status === 401 && this.props.unauthorisedFunc();
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  searchMeetingNote(e) {
    e.preventDefault();
    MeetingNotesServices.searchMeetingNotesBy(
      this.state.searchMeetingNotesBy,
      this.state.meetingNoteValue,
    )
      .then((response) => {
        if (response.message === "List Displayed") {
          this.setState({ meetingNotes: response.data });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  }
  getTrimNumber(value) {
    DevelopmentServices.getTrimNumber(value)
      .then((response) => {
        if (response.message === "List Displayed") {
          let jsonData = [];
          response.data.map((info, index) => {
            let objData = {};
            objData.label = info.trimNumber;
            objData.value = info._id;
            jsonData.push(objData);
          });
          this.setState({ trimNumberInfo: jsonData });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  }

  addEmbellishment(e) {
    e.preventDefault();
    let { manualQty } = this.state;
    manualQty.push(manualQty.length + 1);
    this.setState({ manualQty });
  }

  removeEmbellishment(e, index) {
    let { manualQty } = this.state;
    manualQty.splice(index, 1);
    this.setState({ manualQty });
  }

  getPatternMaster(value, name) {
    DevelopmentServices.getEmployeId(value, name)
      .then((response) => {
        if (response.message === "Operation Successful") {
          let jsonData = [];
          response.data.map((info, index) => {
            let objData = {};
            objData.label = info.userId;
            objData.value = info._id;
            jsonData.push(objData);
          });
          this.setState({ patternMasterInfo: jsonData });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  }

  createProduct(e) {
    e.preventDefault();
    let data = {};
    data.embroideryTab = this.state.embroideryActive;
    data.MNId = this.state.meetingNoteId;
    data.magnumStyleId = this.state.styleNo.value;
    data.refImages = this.state.images;
    let form = document.forms["createProduct"];
    for (var i = 0; i < form.elements.length; i++) {
      data[form.elements[i].name] = form.elements[i].value;
    }
    SampleServices.createProduct(data)
      .then((response) => {
        if (response.message === "Successfully Updated") {
          UtilityService.successMsg(this.msg);
          this.setState({ productId: response.data._id });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  }

  completeProduct(e) {
    SampleServices.completeProduct(this.state.productId)
      .then((response) => {
        if (response.message === "Successfully updated") {
          UtilityService.successMsg(this.msg);
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  }

  addCategoryCount(e, name) {
    let data = this.state[`${name}`];
    let length = this.state[`${name}`].length;
    data.push(length);
    this.setState({ [`${name}`]: data });
  }

  removeCategoryCount(index, name) {
    let data = this.state[`${name}`];
    data.splice(index, 1);
    this.setState({ [`${name}`]: data });
  }

  addDispatch(e, keyname) {
    let { dispatch } = this.state;
    dispatch[keyname].push(this.state.dispatch[keyname].length + 1);
    this.setState({ dispatch: dispatch });
  }

  removeDispatch(e, index, keyname) {
    let { dispatch } = this.state;
    dispatch[keyname].splice(index, 1);
    this.setState({ dispatch: dispatch }, function () {});
  }

  createSampleRequest = (e) => {
    let empObj = {};
    let form = document.forms["sampleRequestForm"];
    for (var i = 0; i < form.elements.length; i++) {
      empObj[form.elements[i].name] = form.elements[i].value;
    }

    SampleServices.createSampleRequest(empObj, this.state.styleNo)
      .then((response) => {
        if (response.message === "Sample request Created") {
          UtilityService.successMsg(this.msg);
          this.setState({
            productId: response.data._id,
            orderDate: response.data.orderDate,
            orderNumber: response.data.requestNumber,
          });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  };

  getDoneBy = (value) => {
    SampleServices.getDoneBy(value)
      .then((response) => {
        if (response.message === "list displayed") {
          let jsonData = [];
          response.data.map((value, index) => {
            let empObj = {};
            empObj.label = value.firstName;
            empObj.value = value._id;
            jsonData.push(empObj);
          });
          this.setState({ doneBy: jsonData });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  };

  changeRequest(e) {
    SampleServices.getAssignTo(e.target.value)
      .then((response) => {
        if (response.message === "Operation Successful") {
          this.setState({ markerId: response.data._id });
        }
      })
      .catch((error) => {
        this.props.getalertMessage("error", error.toString());
      });
  }
  sampleImage(e) {
    let selDiv = "";
    selDiv = document.querySelector("#selectedFiles");
    if (!e.target.files) return;

    selDiv.innerHTML = "";

    var files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];

      selDiv.innerHTML += f.name + "<br/>";
    }
  }
  sampleImagewash(e) {
    let selDivwash = "";
    selDivwash = document.querySelector("#selectedFileswash");
    if (!e.target.files) return;

    selDivwash.innerHTML = "";

    var files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];

      selDivwash.innerHTML += f.name + "<br/>";
    }
  }
  onOpenModal = (e) => {
    this.setState({ modalOpen: true, selectedProcess: e.target.name });
  };

  onCloseModal = () => {
    this.setState({ modalOpen: false });
  };

  //Jayaprakash
  gotoTop = (e) => {
    e.preventDefault();
    var rightSectionDiv = document.getElementById("right-section");
    rightSectionDiv.scrollTop = 0;
  };

  //ToggleList function
  changeToggleList = (e, keyname) => {
    let toggleLists = { ...this.state.toggleLists };
    toggleLists[keyname].toggle = !this.state.toggleLists[keyname].toggle;
    this.setState({
      toggleLists,
    });
  };

  //SwitchList function
  changeSwitchList = (e, keyname) => {
    let switchList = { ...this.state.switchList };
    //
    //
    switchList[keyname].toggle = !this.state.switchList[keyname].toggle;
    this.setState({
      switchList,
    });
  };

  //getUserStatus in process update
  getUserStatus = (e, keyname) => {
    let switchList = { ...this.state.switchList };
    switchList[keyname].userStatus = e.target.value;
    this.setState({
      switchList,
    });
  };

  //EMbroidery section

  goToDiv = (e, divelement) => {
    e.preventDefault();
    var element = document.getElementById(divelement);

    $("#right-section").animate(
      {
        scrollTop: $(element).offset().top - 50,
      },
      1000,
    );
  };

  // Sample module start

  createSampleModule = (e) => {
    e.preventDefault();
    let sample = {};
    sample.sample = { ...this.state.sampleRequest.sample };
    sample.sampleProcess = {
      ...this.state.sampleRequest.processUpdates.sample,
    };
    sample._id = this.state._id;
    SampleServices.createSample(sample)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.sample = response.text.data;

          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeSampleModule = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.sample.comments,
    };
    SampleServices.completeSample(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.sample = { ...response.text.data };
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  updateSampleModule = (name, value, Dataindex) => {
    let { sampleRequest } = this.state;
    if (Dataindex !== undefined) {
      sampleRequest.sample.data[Dataindex][name] = value;
    } else {
      sampleRequest.sample[name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  addSize = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sample.data.push({ size: null, quantity: null });
    this.setState({ sampleRequest });
  };

  removeSize = (dataIndex) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sample.data.splice(dataIndex, 1);
    this.setState({ sampleRequest });
  };

  // Sample module end

  //Cad module start

  saveCAD = (e) => {
    e.preventDefault();
    let cad = {};
    cad.cad = this.state.sampleRequest.cad;
    cad.cadProcess = this.state.sampleRequest.processUpdates.cad;
    cad._id = this.state._id;
    SampleServices.createCAD(cad)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.cad = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeCAD = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.cad.comments,
    };
    SampleServices.completeCAD(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.cad = { ...response.text.data };
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  updateCadValues = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.cad[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  cadUpdate = (...args) => {
    const cad = { ...this.state.sampleRequest.cad };
    const name = args[0];
    const value = args[1];
    cad[name] = value;

    this.setState({
      sampleRequest: {
        ...this.state.sampleRequest,
        cad,
      },
    });
  };

  changeCADRefNum = (cad) => {
    let sampleRequest = { ...this.state.sampleRequest };

    if (cad !== null) {
      DevelopmentServices.getCAD(cad.value)
        .then(async (response) => {
          if (response.status == 200) {
            sampleRequest.cad.cadType = response.text.data.cadType;
            sampleRequest.cad.cadId = cad.value;
            sampleRequest.cad.name = response.text.data.cadName;
            sampleRequest.cad.printEmbType = response.text.data.printType;
            sampleRequest.cad.borderType = response.text.data.borderType;
          }
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString()),
        );
    } else {
      sampleRequest.cad.cadType = [];
      sampleRequest.cad.cadId = null;
      sampleRequest.cad.name = "";
      sampleRequest.cad.printEmbType = "";
      sampleRequest.cad.borderType = "";
    }
    setTimeout(() => {
      this.setState({
        sampleRequest,
      });
    }, 100);
  };

  // Cad module end

  //SampleRequest leftSection Start

  getStyleReferenceInfo = (value) => {
    if (value !== null) {
      this.setState({
        isLoading: true,
      });
      let { sampleRequest, measurementChartData } = this.state;
      sampleRequest.styleReferenceId = value;
      StyleServices.getStyleInfoByReference(value)
        .then((response) => {
          if (response.status === 200) {
            sampleRequest.magnumStyleName = response.text.data.magnumStyleName;
            measurementChartData.magnumStyleName =
              response.text.data.magnumStyleName;
            sampleRequest.customerRefNumber =
              response.text.data.customerRefNumber;
            measurementChartData.customerRefNumber =
              response.text.data.customerRefNumber;
            sampleRequest.magnumStyleId = response.text.data.magnumStyleId;
            measurementChartData.magnumStyleId =
              response.text.data.magnumStyleId;
            sampleRequest.customer = response.text.data.customer;
            measurementChartData.customer = response.text.data.customer;
            sampleRequest.customerDepartmentId =
              response.text.data.customerDepartmentId;
            measurementChartData.customerDepartmentId =
              response.text.data.customerDepartmentId;
            sampleRequest.itemNumber = response.text.data.itemNumber;
            measurementChartData.itemNumber = response.text.data.itemNumber;
            sampleRequest.blockRefNo = response.text.data.blockRefNumber;
            measurementChartData.blockRefNo = response.text.data.blockRefNumber;
            sampleRequest.oldMagStyleNo = response.text.data.refDetail;
            measurementChartData.oldMagStyleNo = response.text.data.refDetail;
            sampleRequest.refColNo = response.text.data.referenceColor;
            measurementChartData.refColNo = response.text.data.referenceColor;
            sampleRequest.magnumBuyerStyleName =
              response.text.data.magnumBuyerStyleName;
            measurementChartData.magnumBuyerStyleName =
              response.text.data.magnumBuyerStyleName;
            this.setState(
              {
                sampleRequest,
                measurementChartData,
              },
              () =>
                this.getMainValues(
                  sampleRequest.customer,
                  sampleRequest.customerDepartmentId,
                ),
            );
            //console.log(this.state.sampleRequest, "sampleRequest");
          }
          response.status == 401 && this.props.unauthorisedFunc();
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString()),
        );
    } else {
      let sampleRequest = { ...this.state.sampleRequest };
      sampleRequest.styleReferenceId = null;
      this.setState({
        sampleRequest,
      });
    }
  };

  updateSampleRequest = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest[name] = value;

    this.setState({
      sampleRequest,
    });
  };

  updateFabricName = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    //console.log(sampleRequest, "sampleRequestname");
    sampleRequest.fabric[index][name] = value;
    //console.log(sampleRequest.fabric[index][name], "sampleRequestname1212");

    this.setState({
      sampleRequest,
    });
  };

  updateCustomerDept = (index, customer, customerDepartmentId) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.customer = customer;
    sampleRequest.customerDepartmentId = customerDepartmentId;
    this.setState({ sampleRequest });
  };

  //SampleRequest LeftSection End

  // Employee list
  getAssignToList = (value) => {
    PermissionServices.searchEmploye(value).then(async (res) => {
      if (res.status == 200) {
        this.setState({ assignedToList: await res.text.data });
      }
    });
  };

  //  Fabric module start
  updateFabric = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.fabric[index][name] = value;
    this.setState({
      sampleRequest,
    });
  };

  getFabricInfo = (fabric, index) => {
    if (fabric != null) {
      SampleServices.getFabricInfo(fabric.value)
        .then(async (response) => {
          if (response.status == 200) {
            let sampleRequest = { ...this.state.sampleRequest };

            sampleRequest.fabric[index].classificationOfFabric =
              response.text.data.classificationOfFabric !== null
                ? response.text.data.classificationOfFabric.name
                : "";
            sampleRequest.fabric[index].countAndConstruction =
              `${response.text.data.count.warp}*${response.text.data.count.weft}/${response.text.data.construction.warp}*${response.text.data.construction.weft}`;
            sampleRequest.fabric[index].quality =
              response.text.data.quality !== null
                ? response.text.data.quality.name
                : "";
            sampleRequest.fabric[index].fabricNumber = fabric.value;
            sampleRequest.fabric[index].bNumber =
              response.text.data.bNumber.baseRefNumber;
            sampleRequest.test1 = response.text.data.bNumber.baseRefNumber;
            this.setState({
              sampleRequest,
            });
          }
          response.status == 404 &&
            this.props.getalertMessage("error", response.text.message);
          response.status == 401 && this.props.unauthorisedFunc();
        })
        .catch((error) => {});
    } else {
      let sampleRequest = { ...this.state.sampleRequest };
      //console.log(this.sampleRequest.fabric,"test fab")
      sampleRequest.fabric[index].fabricNumber = null;
      this.setState({
        sampleRequest,
      });
    }
  };

  addFabric = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (!sampleRequest.fabric.length) {
      DevelopmentServices.getFabricNumber("F-99999")
        .then((response) => {
          if (response.status == 200) {
            sampleRequest.fabric.push({
              fabricId: null,
              fabricNumber: "",
              fabricList: response.text.data,
              fabricPosition: null,
              classificationOfFabric: "",
              quality: "",
              countAndConstruction: "",
              fabricRadio: "notInHse",
            });
            // this.setState({ fabricList: response.text.data })
            this.getFabricInfo(response.text.data[0], 0);
          }
        })
        .catch((error) => {});
    } else {
      sampleRequest.fabric.push({
        fabricId: null,
        fabricNumber: "",
        fabricList: this.props.fabricList,
        fabricPosition: null,
        classificationOfFabric: "",
        quality: "",
        countAndConstruction: "",
        fabricRadio: "notInHse",
      });
    }

    this.setState({
      sampleRequest,
    });
  };

  removeFabric = (index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.fabric.splice(index, 1);
    this.setState({
      sampleRequest,
    });
  };

  createFabric = (e) => {
    e.preventDefault();
    let fabric = {};
    fabric.fabric = this.state.sampleRequest.fabric;
    fabric._id = this.state._id;
    fabric.fabricComments = this.state.sampleRequest.fabricComments;
    fabric.fabricProcess = this.state.sampleRequest.processUpdates.fabric;
    var count = fabric.fabric.reduce(function (n, data) {
      return n + (data.fabricPosition !== null);
    }, 0);

    if (count == fabric.fabric.length) {
      SampleServices.createFabric(fabric)
        .then((response) => {
          if (response.status === 200) {
            // let sampleRequest = { ...this.state.sampleRequest }
            // sampleRequest.fabric = response.text.data
            // this.setState({
            //   sampleRequest
            // })
            this.props.getalertMessage("success", response.text.message);
          } else if (response.status == 401) {
            this.props.unauthorisedFunc();
          } else {
            this.props.getalertMessage("error", response.text.message);
          }
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString()),
        );
    } else {
      this.props.getalertMessage("error", "fabric position mandatory");
    }
  };

  completeFabric = (e) => {
    // e.preventDefault();
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.fabric.comments,
    };
    SampleServices.completeFabric(request)
      .then((response) => {
        if (response.status == 200) {
          sampleRequest.processUpdates.fabric = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  clearDummyFabric = (index) => {
    if (index == 0) {
      let sampleRequest = { ...this.state.sampleRequest };
      sampleRequest.fabric[index].fabricId = null;
      this.setState({
        sampleRequest,
      });
    }
  };

  // Fabric module end

  //trim module start

  getTrimInfo = (trim, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (trim !== null) {
      sampleRequest.trim.row1[index].trimNumber = trim._id;
      sampleRequest.trim.row1[index].description = trim.description;
      sampleRequest.trim.row1[index].quality = trim.quality;
      sampleRequest.trim.row1[index].sizeNumber = trim.sizeNumber;
      sampleRequest.trim.row1[index].size = trim.size;
    } else {
      sampleRequest.trim.row1[index].trimNumber = null;
    }
    this.setState({
      sampleRequest,
    });
    this.samplePrintTrim();
  };

  getTrimInfoRow2 = (trim, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (trim !== null) {
      sampleRequest.trim.row2[index].trimNumber = trim._id;
      sampleRequest.trim.row2[index].description = trim.description;
      sampleRequest.trim.row2[index].quality = trim.quality;
      sampleRequest.trim.row2[index].sizeNumber = trim.sizeNumber;
      sampleRequest.trim.row2[index].size = trim.size;
    }
    this.setState({
      sampleRequest,
    });
    this.samplePrintTrim();
  };

  updateTrim = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.trim[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  updateTrimRow1 = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name === "trimCategory") {
      sampleRequest.trim.row1[index][name] = value;
      sampleRequest.trim.row1[index]["trimNumber"] = null;
      this.setState({
        sampleRequest,
      });
    } else {
      sampleRequest.trim.row1[index][name] = value;
      this.setState({
        sampleRequest,
      });
    }
  };

  updateTrimRow2 = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.trim.row2[index][name] = value;
    this.setState(
      {
        sampleRequest,
      },
      () => this.updateCalcTrim(),
    );
    if (name == "trimCategory") {
      SampleServices.getTrimNumber(value, "")
        .then(async (response) => {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.trim.row2[index].trimList = response.text.data;
          this.setState({
            sampleRequest,
          });
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString()),
        );
    }
  };

  updateCalcTrim = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.trim.row2 = sampleRequest.trim.row2.map((data, index) => {
      if (data.type == "Both Elastic") {
        data.number = this.state.prefillInfo.SAMPLEREQUEST.BOTHELASTIC;
      }
      if (data.type == "Top TTH / Bottom Elastic") {
        data.number =
          this.state.prefillInfo.SAMPLEREQUEST.TOPTTHORBOTTOMELASTIC;
      }
      if (
        data.number !== null &&
        data.noOfRow !== null &&
        data.length !== null
      ) {
        let calc =
          (Number(parseFloat(data.noOfRow)) *
            Number(parseFloat(data.length)) *
            Number(parseFloat(data.number))) /
          100;
        data.totalReq = (calc + calc * 0.1).toFixed(2);
      }
      return data;
    });
    this.setState({
      sampleRequest,
    });
  };

  addTrim = (keyName) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let prefillInfo = this.state.prefillInfo;
    let trimCategory =
      prefillInfo.TRIM.TRIMCATEGORY &&
      prefillInfo.TRIM.TRIMCATEGORY.find(
        (x) => x.label.toLowerCase() === "thread",
      ).value;

    SampleServices.getTrimNumber(trimCategory, "th-00001")
      .then(async (response) => {
        let rowdata = {
          trimId: response.text.data[0]._id,
          trimCategory: trimCategory,
          trimNumber: response.text.data[0]._id,
          description: response.text.data[0].description,
          size: response.text.data[0].size,
          quality: response.text.data[0].quality,
          sizeNumber: response.text.data[0].sizeNumber,
          trimRadio: "notInHse",
          trimList: response.text.data,
        };

        if (!sampleRequest.trim[keyName]) {
          sampleRequest.trim = {
            [keyName]: [rowdata],
          };
        } else {
          sampleRequest.trim[keyName] = [
            ...sampleRequest.trim[keyName],
            rowdata,
          ];
        }

        this.setState({
          sampleRequest,
        });
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  removeTrim = (keyName, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.trim[keyName].splice(index, 1);
    this.setState({
      sampleRequest,
    });
  };

  createTrim = (e) => {
    e.preventDefault();
    let trim = {};
    trim.trim = this.state.sampleRequest.trim;
    trim.trimProcess = this.state.sampleRequest.processUpdates.trim;
    trim._id = this.state._id;
    SampleServices.createTrim(trim)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          let row1 = sampleRequest.trim.row1,
            row2 = sampleRequest.trim.row2;
          sampleRequest.trim = response.text.data;
          sampleRequest.trim.row1 = row1;
          sampleRequest.trim.row2 = row2;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeTrim = (e) => {
    // e.preventDefault();
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.trim.comments,
    };
    SampleServices.completeTrim(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.trim = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //trim module end

  // common for pattern,sewing,cutting

  updatePatternCheck = (name, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.pattern.logs[i][name] = new Date();
    this.setState({
      sampleRequest,
    });
  };

  ///pattern module start

  updatePattern = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.pattern[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  updatePatternLog = (name, value, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name == "timeIn" || name == "timeOut") {
      sampleRequest.pattern.logs[i][name] = new Date();
    } else {
      sampleRequest.pattern.logs[i][name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  addPatternLog = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.pattern.logs.push({
      remarks: "",
      timeIn: "",
      timeOut: "",
      breakTime: "",
      reason: "",
    });

    this.setState({
      sampleRequest,
    });
  };

  removePatternLog = (i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.pattern.logs.splice(i, 1);
    this.setState({
      sampleRequest,
    });
  };

  createPattern = (e) => {
    e.preventDefault();
    let pattern = {};
    pattern.pattern = { ...this.state.sampleRequest.pattern };
    pattern.patternProcess = {
      ...this.state.sampleRequest.processUpdates.pattern,
    };
    pattern._id = this.state._id;
    const { sample } = this.state.sampleRequest.toggle;
    const { status } = this.state.sampleRequest.processUpdates.sample;

    if (
      sample &&
      status !== "COMPLETED" &&
      this.state.sampleRequest.processUpdates.pattern.status === "COMPLETED"
    ) {
      return this.props.getalertMessage(
        "error",
        "Sample process need to complete!",
        5000,
      );
    }
    SampleServices.createPattern(pattern)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.pattern = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completePattern = (e) => {
    // e.preventDefault();
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.pattern.comments,
    };
    const { sample } = sampleRequest.toggle;
    const { status } = sampleRequest.processUpdates.sample;

    if (sample && status !== "COMPLETED") {
      return this.props.getalertMessage(
        "error",
        "Sample process need to complete!",
        5000,
      );
    }
    SampleServices.completePattern(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.pattern = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //pattern module end

  // cutting module start

  updateCutting = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name === "cuttingMasterName") {
      if (value !== null) {
        sampleRequest.cutting[name] = value.value;
      } else {
        sampleRequest.cutting[name] = null;
      }
    } else {
      sampleRequest.cutting[name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  updateCuttingLog = (name, value, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name == "timeIn" || name == "timeOut") {
      sampleRequest.cutting.logs[i][name] = new Date();
    } else {
      sampleRequest.cutting.logs[i][name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  updateCuttingCheck = (name, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.cutting.logs[i][name] = new Date();
    this.setState({
      sampleRequest,
    });
  };

  addCuttingLog = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.cutting.logs.push({
      remarks: "",
      timeIn: "",
      timeOut: "",
      breakTime: "",
      reason: "",
    });

    this.setState({
      sampleRequest,
    });
  };

  removeCuttingLog = (i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.cutting.logs.splice(i, 1);
    this.setState({
      sampleRequest,
    });
  };

  createCutting = (e) => {
    let data = {};
    data.cutting = this.state.sampleRequest.cutting;
    data.cuttingProcess = {
      ...this.state.sampleRequest.processUpdates.cutting,
    };
    data._id = this.state._id;
    const { pattern, fabric } = this.state.sampleRequest.toggle;
    const patternStatus =
      this.state.sampleRequest.processUpdates.pattern.status;
    const fabricStatus = this.state.sampleRequest.processUpdates.fabric.status;

    if (
      this.state.sampleRequest.processUpdates.cutting.status === "COMPLETED" &&
      ((pattern && patternStatus !== "COMPLETED") ||
        (fabric && fabricStatus !== "COMPLETED"))
    ) {
      return this.props.getalertMessage(
        "error",
        "Pattern and Fabric should complete!",
        5000,
      );
    }
    SampleServices.createCutting(data)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.cutting = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeCutting = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.cutting.comments,
    };
    const { pattern, fabric } = this.state.sampleRequest.toggle;
    const patternStatus =
      this.state.sampleRequest.processUpdates.pattern.status;
    const fabricStatus = this.state.sampleRequest.processUpdates.fabric.status;

    if (
      (pattern && patternStatus !== "COMPLETED") ||
      (fabric && fabricStatus !== "COMPLETED")
    ) {
      return this.props.getalertMessage(
        "error",
        "Pattern and Fabric should complete!",
        5000,
      );
    }
    SampleServices.completeCutting(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.cutting = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //cutting module end

  // Sewing module start
  updateSewing1 = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name === "smokingOrShiring") {
      sampleRequest.sewing.smokingOrShiring =
        !sampleRequest.sewing.smokingOrShiring;
    } else {
      sampleRequest.sewing[name] = value;
    }
    this.setState(
      {
        sampleRequest,
      },
      () => this.onSmockingShirring(),
    );
  };

  onSmockingShirring = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (
      sampleRequest.sewing &&
      sampleRequest.sewing.trimData &&
      sampleRequest.sewing.trimData.length > 0
    ) {
      sampleRequest.sewing.trimData.forEach((x, i) => {
        if (x.trimCategory) {
          SampleServices.getTrimNumber(x.trimCategory)
            .then(async (response) => {
              sampleRequest.sewing.trimData[i].trimList = response.text.data;
            })
            .catch((error) => alert(error.toString()));
        }
      });
    } else {
      sampleRequest.sewing.trimData = [];
      if (sampleRequest.sewing.trimData.length === 0) {
        let prefillInfo = { ...this.state.prefillInfo.TRIM };
        let trimCategory =
          prefillInfo.TRIMCATEGORY &&
          prefillInfo.TRIMCATEGORY.filter(
            (x) => x.label.toLowerCase() === "thread",
          )[0].value;
        SampleServices.getTrimNumber(trimCategory, "")
          .then(async (response) => {
            // let sampleRequest = { ...this.state.sampleRequest };
            sampleRequest.sewing.trimData[0] = {
              trimId: null,
              trimCategory: trimCategory,
              trimNumber: "",
              description: "",
              size: "",
              quality: "",
              sizeNumber: "",
              trimRadio: "notInHse",
            };
            sampleRequest.sewing.trimData[0].trimList = response.text.data;
            this.setState({
              sampleRequest,
            });
          })
          .catch((error) =>
            this.props.getalertMessage("error", error.toString()),
          );
      }
    }

    this.setState({
      sampleRequest,
    });
  };

  smockingShirringaddTrim = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    let prefillInfo = { ...this.state.prefillInfo.TRIM };
    let trimCategory =
      prefillInfo.TRIMCATEGORY &&
      prefillInfo.TRIMCATEGORY.filter(
        (x) => x.label.toLowerCase() === "thread",
      )[0].value;
    SampleServices.getTrimNumber(trimCategory, "")
      .then(async (response) => {
        // let sampleRequest = { ...this.state.sampleRequest };
        sampleRequest.sewing.trimData.push({
          trimId: null,
          trimCategory: trimCategory,
          trimNumber: "",
          description: "",
          size: "",
          quality: "",
          sizeNumber: "",
          trimRadio: "notInHse",
        });

        sampleRequest.sewing.trimData[
          sampleRequest.sewing.trimData.length - 1
        ].trimList = response.text.data;
        this.setState({
          sampleRequest,
        });
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  smockingShirringremoveTrim = (index) => {
    let sampleRequest = { ...this.state.sampleRequest };

    sampleRequest.sewing.trimData.splice(index, 1);
    this.setState({
      sampleRequest,
    });
  };

  updateSewing = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name === "tailorName") {
      if (value !== null) {
        sampleRequest.sewing.sewingData[index][name] = value.value;
      } else {
        sampleRequest.sewing.sewingData[index][name] = null;
      }
    } else {
      sampleRequest.sewing.sewingData[index][name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  updateSewingTrimData = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sewing.trimData[index][name] = value;
    this.setState(
      {
        sampleRequest,
      },
      () => this.updateCalcSewing(),
    );
    if (name == "trimCategory") {
      SampleServices.getTrimNumber(value, "")
        .then(async (response) => {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.sewing.trimData[index].trimList = response.text.data;
          this.setState({
            sampleRequest,
          });
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString()),
        );
    }
  };

  getTrimInfoSewTrimData = (trim, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (trim !== null) {
      sampleRequest.sewing.trimData[index].trimNumber = trim._id;
      sampleRequest.sewing.trimData[index].description = trim.description;
      sampleRequest.sewing.trimData[index].quality = trim.quality;
      sampleRequest.sewing.trimData[index].sizeNumber = trim.sizeNumber;
      sampleRequest.sewing.trimData[index].size = trim.size;
    } else {
      sampleRequest.sewing.trimData[index].trimNumber = null;
    }
    this.setState({
      sampleRequest,
    });
  };

  updateCalcSewing = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    const { smockingorElastic, toptthElastic } =
      this.state.prefillInfo.SAMPLEREQUEST.SHIRRINGORSMOCKING;
    sampleRequest.sewing.trimData = sampleRequest.sewing.trimData.map(
      (data, index) => {
        if (data.type == "Both Elastic") {
          data.multiple = Number(smockingorElastic.multiple);
          data.wastage = Number(smockingorElastic.wastage);
        }
        if (data.type == "Top TTH / Bottom Elastic") {
          data.multiple = Number(toptthElastic.multiple);
          data.wastage = Number(toptthElastic.wastage);
        }
        if (
          data.multiple !== null &&
          data.noOfRow !== null &&
          data.length !== null
        ) {
          let calc =
            Number(parseFloat(data.noOfRow)) *
            Number(parseFloat(data.length)) *
            Number(parseFloat(data.multiple));
          // /100
          data.totalReq = Number(
            (calc + calc * (data.wastage / 100)).toFixed(2),
          );
        }
        return data;
      },
    );
    this.setState({
      sampleRequest,
    });
  };

  addSewing = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sewing.sewingData.push({
      tailorName: null,
      sewingType: null,
      size: "",
      quantity: "",
      approvalStatus: "",
      rejected: "",
      logs: [
        // {
        //   remarks: "",
        //   timeIn: "",
        //   timeOut: "",
        //   breakTime: "",
        //   reason: ""
        // }
      ],
    });
    this.setState({
      sampleRequest,
    });
  };

  removeSewing = (index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    // sampleRequest.sewing.sewingData = sampleRequest.sewing.sewingData.filter((d,i) => i != index)
    sampleRequest.sewing.sewingData.splice(index, 1);
    this.setState({
      sampleRequest,
    });
  };

  updateSewingLog = (name, value, i, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name == "timeIn" || name == "timeOut") {
      sampleRequest.sewing.sewingData[index].logs[i][name] = new Date();
    } else {
      sampleRequest.sewing.sewingData[index].logs[i][name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  updateSewingCheck = (name, i, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sewing.sewingData[index].logs[i][name] = new Date();
    this.setState({
      sampleRequest,
    });
  };

  addSewingLog = (index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sewing.sewingData[index].logs.push({
      remarks: "",
      timeIn: "",
      timeOut: "",
      breakTime: "",
      reason: "",
    });

    this.setState({
      sampleRequest,
    });
  };

  removeSewingLog = (i, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sewing.sewingData[index].logs.splice(i, 1);
    this.setState({
      sampleRequest,
    });
  };

  createSewing = (e) => {
    e.preventDefault();
    let data = {};
    let sewing = { ...this.state.sampleRequest.sewing };
    if (!sewing.smokingOrShiring) {
      sewing.trimData = [];
    }
    data.sewing = sewing;

    data.sewingProcess = this.state.sampleRequest.processUpdates.sewing;
    data._id = this.state._id;
    const { cutting } = this.state.sampleRequest.toggle;
    const { status } = this.state.sampleRequest.processUpdates.cutting;

    if (
      this.state.sampleRequest.processUpdates.sewing.status === "COMPLETED" &&
      cutting &&
      status !== "COMPLETED"
    ) {
      return this.props.getalertMessage(
        "error",
        "Cutting process need to complete!",
        5000,
      );
    }
    SampleServices.createSewing(data)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };

          const sewingData = sampleRequest.sewing.sewingData;
          const trimData = sampleRequest.sewing.trimData;
          sampleRequest.sewing = response.text.data;
          sampleRequest.sewing.sewingData = sewingData;
          sampleRequest.sewing.trimData = trimData;

          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeSewing = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.sewing.comments,
    };
    const { cutting } = sampleRequest.toggle;
    const { status } = sampleRequest.processUpdates.cutting;

    if (cutting && status !== "COMPLETED") {
      return this.props.getalertMessage(
        "error",
        "Cutting process need to complete!",
        5000,
      );
    }
    SampleServices.completeSewing(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.sewing = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //Sewing module end

  //garment technologiest module start

  updateGarment = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.garmentTechnologist[name] = value;
    this.setState([sampleRequest]);
  };

  updateGarmentForm = (name, arrKey, value, i) => {
    // console.log("gdshgdhsdg",name, arrKey, value, i);

    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.garmentTechnologist.sampleForm[arrKey][i][name] = value;
    this.setState({
      sampleRequest,
    });
  };

  addGarmentForm = (arrKey) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.garmentTechnologist.sampleForm[arrKey].push({
      comments: "",
      fab: false,
      trims: false,
      workManShip: false,
      buyerChanges: false,
      pat: false,
      remarks: "",
    });
    this.setState({
      sampleRequest,
    });
  };

  removeGarmentForm = (arrKey, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.garmentTechnologist.sampleForm[arrKey] =
      sampleRequest.garmentTechnologist.sampleForm[arrKey].filter(
        (d, ind) => ind != i,
      );
    this.setState({
      sampleRequest,
    });
  };

  createGarment = (e) => {
    e.preventDefault();
    let info = {};
    info.garmentTechnologist = this.state.sampleRequest.garmentTechnologist;
    info.garmentProcess =
      this.state.sampleRequest.processUpdates.garmentTechnologist;
    info._id = this.state._id;
    SampleServices.createGarment(info)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.garmentTechnologist = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  getCustomerDepartmentName = (value) => {
    this.setState({
      customerDepartment: value,
    });
    //console.log(this.state.customerDepartment,"cuDe")
  };

  printGarment = (val) => {
    let printGarmentTech = {};
    printGarmentTech = { ...this.state.sampleRequest.garmentTechnologist };
    printGarmentTech.HEADERS = {
      ...this.state.sampleRequest.processUpdates.garmentTechnologist,
    };
    printGarmentTech.customerDepartment = { ...this.state.customerDepartment };
    printGarmentTech.styleNo =
      this.state.styleNoInfo &&
      this.state.styleNoInfo.length > 0 &&
      this.state.styleNoInfo.find(
        (style) => style.value === this.state.sampleRequest.styleReferenceId,
      );
    printGarmentTech.styleName = this.state.sampleRequest.magnumStyleName;
    printGarmentTech.sampleRequestDate = moment(
      this.state.sampleRequest.createdAt,
    ).format("Do MMM YYYY");
    printGarmentTech.sampleType =
      this.state.prefillInfo.SAMPLEREQUEST &&
      this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE &&
      this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE.length > 0 &&
      this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE.find(
        (sample) => sample.value === this.state.sampleRequest.sampleType,
      );
    printGarmentTech.sampleDated =
      this.state.sampleRequest.garmentTechnologist.sampleDate !== null
        ? moment(
            this.state.sampleRequest.garmentTechnologist.sampleDate,
          ).format("Do MMM YYYY")
        : "";
    printGarmentTech.gmtTech =
      this.state.sampleRequest.garmentTechnology !== null
        ? this.state.sampleRequest.garmentTechnology
        : "GARMENT TECH NOT ASSIGNED";
    // printGarmentTech.patternMaster = this.state.assignedToList.find(x=>)

    this.setState(
      {
        printGarmentLoading: true,
        printGarmentTech,
      },
      () => {
        var divToPrint = document.getElementById(val);

        var newWin = window.open("", "mywindow");
        newWin.document.write(divToPrint.outerHTML);
        newWin.focus();
        newWin.print();
        newWin.close();
      },
    );
  };

  printFabric = () => {
    var divToPrint = document.getElementById("fabricForm");

    html2canvas(divToPrint).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/jpg");
      var newWin = window.open("", "mywindow");
      var img = newWin.document.createElement("img");
      img.src = imgData;
      await newWin.document.body.appendChild(img);
      await newWin.focus();
      await newWin.print();
      await newWin.close();
    });
  };

  onLoadFinish = () => {
    this.setState({
      isLoading: false,
    });
  };

  completeGarment = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.garmentTechnologist.comments,
    };
    SampleServices.completeGarment(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.garmentTechnologist = {
            ...response.text.data,
          };
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //garment technologist module end

  //embellishment module start
  updateEmbellishment = (name, value, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embellishment[index][name] = value;
    this.setState({
      sampleRequest,
    });
  };

  addEmb = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embellishment.push({
      embType: null,
      hoursMinutes: null,
      pricePerHalfHour: null,
    });
    this.setState({
      sampleRequest,
    });
  };

  removeEmb = (index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embellishment.splice(index, 1);
    this.setState({
      sampleRequest,
    });
  };

  createEmbellishment = (e) => {
    let info = {};
    info.embellishment = this.state.sampleRequest.embellishment;
    info.embellishmentProcess =
      this.state.sampleRequest.processUpdates.embellishment;
    info.embellishmentComments = this.state.sampleRequest.embellishmentComments;
    info._id = this.state._id;
    SampleServices.createEmbelishment(info)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.embellishment = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeEmbellishment = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.embellishment.comments,
    };
    SampleServices.completeEmbelishment(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.embellishment = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //embellishment module end

  //embroidery module start

  updateEmbroidery = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  moveToRight = () => {
    var x = document.getElementById("mySelect").selectedIndex;
    // var y = document.getElementById("mySelect").options;
    // // alert("Index: " + y[x].index + " is " + y[x].text);
    // var z = document.getElementById("mySelect2");
    // var option = document.createElement("option");
    // option.text = document.getElementById("mySelect").value;
    // z.add(option);

    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.rightData.push(
      document.getElementById("mySelect").value,
    );
    sampleRequest.embroidery.leftData.splice(
      document.getElementById("mySelect").selectedIndex,
      1,
    );

    this.setState({ sampleRequest });
    // document.getElementById("mySelect").remove(y[x].index);
  };

  moveToLeft = () => {
    var x = document.getElementById("mySelect2").selectedIndex;
    // var y = document.getElementById("mySelect2").options;
    // // alert("Index: " + y[x].index + " is " + y[x].text);
    // var z = document.getElementById("mySelect");
    // var option = document.createElement("option");
    // option.text = document.getElementById("mySelect2").value;
    // z.add(option);
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.leftData.push(
      document.getElementById("mySelect2").value,
    );
    sampleRequest.embroidery.rightData.splice(
      document.getElementById("mySelect2").selectedIndex,
      1,
    );

    this.setState({ sampleRequest });

    // document.getElementById("mySelect2").remove(y[x].index);
  };

  moveToUp = () => {
    var x = document.getElementById("mySelect2").selectedIndex;
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.rightData = this.swapIndices(
      sampleRequest.embroidery.rightData,
      x,
      x - 1,
    );
    this.setState({ sampleRequest });
  };
  moveToBottom = () => {
    var x = document.getElementById("mySelect2").selectedIndex;
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.rightData = this.swapIndices(
      sampleRequest.embroidery.rightData,
      x,
      x + 1,
    );
    this.setState({ sampleRequest });
  };

  swapIndices = (array, index1, index2) => {
    const newArray = array.slice();
    newArray[index1] = array[index2];
    newArray[index2] = array[index1];
    return newArray;
  };

  changeBackingArray = (action, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    action === "add"
      ? sampleRequest.embroidery.backingData.push({
          backingType: null,
          width: null,
          placement: null,
        })
      : sampleRequest.embroidery.backingData.splice(index, 1);
    this.setState({ sampleRequest });
  };

  addEmbroideryData = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.embroideryData.push({
      embPlacement: null,
      embForm: null,
      noOfCols: null,
      frames: null,
      stitchesMtr: "",
      consumption: "",
      stitchCount: "",
      priceForStitches: "",
    });
    this.setState({
      sampleRequest,
    });
  };

  removeEmbroideryData = (i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.embroideryData =
      sampleRequest.embroidery.embroideryData.filter((d, ind) => ind != i);
    this.setState({
      sampleRequest,
    });
  };

  saveEmbroidery = (e) => {
    e.preventDefault();
    let info = {};
    info.embroidery = this.state.sampleRequest.embroidery;
    info.embroideryProcess = this.state.sampleRequest.processUpdates.embroidery;
    info._id = this.state._id;
    SampleServices.createEmbroidery(info)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.embroidery = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeEmbroidery = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.embroidery.comments,
    };
    SampleServices.completeEmbroidery(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.embroidery = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //backing

  updateEmbroideryBackingData = (name, value, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.embroidery.backingData[i][name] = value;
    this.setState({
      sampleRequest,
    });

    if (name == "backingType") {
      this.state.prefillInfo.SYSTEMSAMPLEREQUEST.BACKINGTYPE.map(
        (data, index) => {
          if (data.value == value) {
            let widthList = [];
            data.typeMultiple.map((dat1) => {
              widthList.push({
                label: dat1.width,
                value: dat1.width,
              });
            });
            this.setState({
              widthList,
            });
          }
        },
      );
    }
  };

  updateEmbroideryData = (name, value, i) => {
    let sampleRequest = { ...this.state.sampleRequest };

    sampleRequest.embroidery.embroideryData[i][name] = value;
    if (name === "consumption" || name === "stitchesMtr") {
      let consumption = sampleRequest.embroidery.embroideryData[i].consumption
        ? sampleRequest.embroidery.embroideryData[i].consumption
        : 0;
      let stitches = sampleRequest.embroidery.embroideryData[i].stitchesMtr
        ? sampleRequest.embroidery.embroideryData[i].stitchesMtr
        : 0;
      let stitchCount = consumption * stitches;
      sampleRequest.embroidery.embroideryData[i].stitchCount =
        Number(stitchCount).toFixed(2);
    }
    if (name === "embForm") {
      sampleRequest.embroidery.embroideryData[i][name] = value;
      sampleRequest.embroidery.embroideryData[i].priceForStitches =
        this.state.prefillInfo.SAMPLEREQUEST.EMBFORM.find(
          (x) => x.label === value,
        ).price;
    } else {
      sampleRequest.embroidery.embroideryData[i][name] = value;
    }

    this.setState({
      sampleRequest,
    });
  };
  //embroidery module end

  //wash moduel start

  changeWashData = (action, index) => {
    let sampleRequest = { ...this.state.sampleRequest };
    action === "add"
      ? sampleRequest.wash.washData.push({
          washType: null,
          washFrom: "5ce7c64ddbc5c3151d061e5f",
          laundryUnit: null,
          price: null,
          // price: this.state.prefillInfo.WASH.PRICEPERKG[0].label
        })
      : sampleRequest.wash.washData.splice(index, 1);
    this.setState({ sampleRequest });
  };
  updateWash = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.wash[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  updateWash1 = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (name === "washType") {
      let washData = this.state.prefillInfo.WASH.WASHTYPE.find(
        (x) => x.value === value,
      );
      sampleRequest.wash.washData.price = (washData && washData.price) || "";
    }
    sampleRequest.wash.washData[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  createWash = (e) => {
    e.preventDefault();
    let info = {};
    info.wash = this.state.sampleRequest.wash;
    info.washProcess = this.state.sampleRequest.processUpdates.wash;
    info._id = this.state._id;
    SampleServices.createWash(info)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.wash = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeWash = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.wash.comments,
    };
    SampleServices.completeWash(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.wash = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };
  // wash module end

  //qc module start

  updateQc = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.qc[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  createQC = (e) => {
    e.preventDefault();
    let info = {};
    info.qc = this.state.sampleRequest.qc;
    info.qcProcess = this.state.sampleRequest.processUpdates.qc;
    info._id = this.state._id;
    SampleServices.createQC(info)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.qc = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeQC = (e) => {
    // e.preventDefault();
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.qc.comments,
    };
    SampleServices.completeQC(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.qc = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //qc module end

  //dispatch module start

  updateDispatch = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.dispatch[name] = value;
    this.setState({
      sampleRequest,
    });
  };

  udpateDispatchValues = (name, value, i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.dispatch.data[i][name] = value;
    this.setState({
      sampleRequest,
    });
  };

  addDispatchData = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.dispatch.data.push({
      location: null,
      date: moment().subtract(1, "day").format(),
      courier: null,
      awbNumber: "",
      size: null,
      quantity: null,
    });
    this.setState({
      sampleRequest,
    });
  };

  removeDispatchData = (i) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.dispatch.data = sampleRequest.dispatch.data.filter(
      (d, ind) => ind != i,
    );
    this.setState({
      sampleRequest,
    });
  };

  createDispatch = (e) => {
    e.preventDefault();
    let objData = {};
    objData.dispatch = this.state.sampleRequest.dispatch;
    objData.dispatchProcess = this.state.sampleRequest.processUpdates.dispatch;
    objData._id = this.state._id;
    const { sewing, wash } = this.state.sampleRequest.toggle;
    const { status } = this.state.sampleRequest.processUpdates.sewing;
    const washStatus = this.state.sampleRequest.processUpdates.wash.status;
    if (this.state.sampleRequest.processUpdates.dispatch.status === "COMPLETED")
      if (sewing && status !== "COMPLETED") {
        return this.props.getalertMessage(
          "error",
          "Sewing process need to complete!",
          5000,
        );
      } else if (
        wash &&
        (washStatus === "PENDING" || washStatus === "IN PROCESS")
      ) {
        return this.props.getalertMessage(
          "error",
          "Washing process need to complete or cancel!",
          5000,
        );
      }
    SampleServices.createDispatch(objData)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.wash = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeDispatch = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.dispatch.comments,
    };
    const { sewing, wash } = sampleRequest.toggle;
    const { status } = sampleRequest.processUpdates.sewing;
    const washStatus = sampleRequest.processUpdates.wash.status;
    if (sewing && status !== "COMPLETED") {
      return this.props.getalertMessage(
        "error",
        "Sewing process need to complete!",
        5000,
      );
    } else if (
      wash &&
      (washStatus === "PENDING" || washStatus === "IN PROCESS")
    ) {
      return this.props.getalertMessage(
        "error",
        "Washing process need to complete or cancel!",
        5000,
      );
    }
    SampleServices.completeDispatch(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.dispatch = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //dispatch module end

  //marker module start

  updateMarker = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.marker[name] = value;
    this.setState([sampleRequest]);
  };

  createMarker = (e) => {
    e.preventDefault();
    let objData = {};
    objData.marker = this.state.sampleRequest.marker;
    objData.markerProcess = this.state.sampleRequest.processUpdates.marker;
    objData._id = this.state._id;
    SampleServices.createMarker(objData)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.marker = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeMarker = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.marker.comments,
    };
    SampleServices.completeMarker(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.marker = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //marker module end

  //costing module start
  createCosting = (e) => {
    e.preventDefault();
    let objData = {};
    objData.costingComments = this.state.sampleRequest.costingComments;
    objData.costingProcess = this.state.sampleRequest.processUpdates.costing;
    objData._id = this.state._id;
    SampleServices.createCosting(objData)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.costing = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeCosting = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.costing.comments,
    };
    SampleServices.completeCosting(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.costing = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  viewCostingPage = () => {
    if (!this.state._id) {
      this.props.getalertMessage("info", "Please Create Request First");
    } else {
      this.props.history.push("/list", {
        moduleName: "COSTING",
        type: "list",
        sampleRequestId: this.state._id,
      });
    }
  };

  createCostingPage = () => {
    if (!this.state._id) {
      this.props.getalertMessage("info", "Please Create Request First");
    } else {
      this.props.history.push("/CostingPage", {
        action: "add",
        _id: "",
        sampleRequestId: this.state._id,
      });
    }
  };

  ///costing module end

  //signoff module start

  createSignOff = (e) => {
    e.preventDefault();
    let objData = {};
    objData.signOffComments = this.state.sampleRequest.signOffComments;
    objData.signOffProcess = this.state.sampleRequest.processUpdates.signOff;
    objData._id = this.state._id;
    SampleServices.createSignOff(objData)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.signOffComments = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  completeSignoff = (e) => {
    let sampleRequest = { ...this.state.sampleRequest };
    let request = {
      _id: this.state._id,
      comments: sampleRequest.processUpdates.signOff.comments,
    };
    SampleServices.completeSignOff(request)
      .then((response) => {
        if (response.status === 200) {
          sampleRequest.processUpdates.signOff = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  //signoff module end

  updateKeyNameValues = (name, value, index, keyName) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest[keyName][index][name] = value;
    this.setState({
      sampleRequest,
    });
  };

  //processupdate
  updateProcessUpdate = (name, value, keyname) => {
    let sampleRequest = { ...this.state.sampleRequest },
      userDetails = { ...this.props.userDetails };

    if (value === "COMPLETED") {
      switch (keyname) {
        case "sample":
          this.completeSampleModule();
          break;
        case "cad":
          this.completeCAD();
          break;
        case "fabric":
          this.completeFabric();
          break;
        case "trim":
          this.completeTrim();
          break;
        case "pattern":
          this.completePattern();
          break;
        case "cutting":
          this.completeCutting();
          break;
        case "sewing":
          this.completeSewing();
          break;
        case "garmentTechnologist":
          this.completeGarment();
          break;
        case "embellishment":
          this.completeEmbellishment();
          break;
        case "embroidery":
          this.completeEmbroidery();
          break;
        case "wash":
          this.completeWash();
          break;
        case "dispatch":
          this.completeDispatch();
          break;
        case "qc":
          this.completeQC();
          break;
        case "marker":
          this.completeMarker();
          break;
        case "costing":
          this.completeCosting();
          break;
        case "signOff":
          this.completeSignoff();
          break;
      }
    } else {
      if (name == "assignedTo") {
        if (value !== null) {
          sampleRequest.processUpdates[keyname][name] = value.value;
        } else {
          sampleRequest.processUpdates[keyname][name] = null;
        }
      } else {
        sampleRequest.processUpdates[keyname][name] = value;
      }
      sampleRequest.processUpdates[keyname].updatedBy = userDetails._id;
      this.setState({
        sampleRequest,
      });
    }
  };

  ProcessUpdates = (e) => {
    e.preventDefault();
    let objData = {};
    objData.processUpdates = this.state.sampleRequest.processUpdates;
    objData._id = this.state._id;
    SampleServices.ProcessUpdates(objData)
      .then((response) => {
        if (response.status === 200) {
          let sampleRequest = { ...this.state.sampleRequest };
          sampleRequest.processUpdates = response.text.data;
          this.setState({
            sampleRequest,
          });
          this.props.getalertMessage("success", response.text.message);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc();
        } else {
          this.props.getalertMessage("error", response.text.message);
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  // SampleRequest

  saveSampleRequest = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    SampleServices.createSampleRequest(sampleRequest)
      .then(async (response) => {
        if (response.status == 200) {
        }
      })
      .catch((error) => {});
  };

  //scroll

  scrollToModule = (moduleName) => {
    if (this.state.sampleRequest.toggle[moduleName]) {
      var moduleEle = document.getElementById(moduleName);
      moduleEle.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    // moduleEle.scrollIntoView(false)
    // moduleEle.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  };

  //type
  handleselectedType = (type) => {
    // let sampleRequest = JSON.parse(this.state.emptyData)
    let sampleRequest = { ...this.state.sampleRequest };
    // let sampleRequest = { ...this.state.emptyData };
    sampleRequest.selectedType = type;
    if (type === "costingRequest") {
      sampleRequest.toggle = {
        sample: false,
        garmentTechnologist: false,
        cad: false,
        fabric: true,
        trim: true,
        pattern: true,
        cutting: false,
        sewing: false,
        embellishment: false,
        embroidery: false,
        wash: false,
        dispatch: false,
        qc: true,
        marker: true,
        costing: true,
        signOff: true,
      };
    } else {
      sampleRequest.toggle = {
        sample: true,
        garmentTechnologist: true,
        cad: false,
        fabric: true,
        trim: true,
        pattern: true,
        cutting: true,
        sewing: true,
        embellishment: false,
        embroidery: false,
        wash: false,
        dispatch: true,
        qc: true,
        marker: true,
        costing: true,
        signOff: true,
      };
    }

    this.setState({
      // sampleRequest:
      sampleRequest,
      selected: type,
    });
  };

  //refimages

  getRefImages = (refImages, moduleName) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest[moduleName].refImages = refImages;
    this.setState({
      sampleRequest,
    });
  };

  //Assingned to , status , completed date update

  updateModulesMain = async (name, value, moduleName) => {
    let sampleRequest = { ...this.state.sampleRequest };
    if (
      name === "status" &&
      value === "COMPLETED" &&
      ["pattern", "cutting", "sewing", "dispatch"].includes(moduleName)
    ) {
      const { isErr, message } = await this.shouldTodo(
        name,
        value,
        moduleName,
        sampleRequest,
      );
      if (isErr) return this.props.getalertMessage("error", message, 5000);
    }
    if (name == "assignedTo") {
      sampleRequest.processUpdates[moduleName][name] =
        value !== null ? value.value : null;
    } else if (name == "status") {
      sampleRequest.processUpdates[moduleName][name] = value;
      if (value === "COMPLETED") {
        sampleRequest.processUpdates[moduleName].processDate = new Date();
      }
    } else {
      sampleRequest.processUpdates[moduleName][name] = value;
    }
    this.setState({
      sampleRequest,
    });
  };

  shouldTodo = (name, value, moduleName, sampleRequest) => {
    return new Promise((resolve, reject) => {
      try {
        switch (moduleName) {
          case "pattern": {
            const { sample } = sampleRequest.toggle;
            const { status } = sampleRequest.processUpdates.sample;

            if (sample && status !== "COMPLETED") {
              return resolve({
                isErr: true,
                message: "Sample process need to complete!",
              });
            }
            return resolve({ isErr: false });
          }
          case "cutting": {
            const { pattern, fabric } = this.state.sampleRequest.toggle;
            const patternStatus =
              this.state.sampleRequest.processUpdates.pattern.status;
            const fabricStatus =
              this.state.sampleRequest.processUpdates.fabric.status;

            if (
              (pattern && patternStatus !== "COMPLETED") ||
              (fabric && fabricStatus !== "COMPLETED")
            ) {
              return resolve({
                isErr: true,
                message: "Pattern and Fabric should complete!",
              });
            }
            return resolve({ isErr: false });
          }
          case "sewing": {
            const { cutting } = sampleRequest.toggle;
            const { status } = sampleRequest.processUpdates.cutting;

            if (cutting && status !== "COMPLETED") {
              return resolve({
                isErr: true,
                message: "Cutting process need to complete!",
              });
            }
            return resolve({ isErr: false });
          }
          case "dispatch": {
            const { sewing, wash } = sampleRequest.toggle;
            const { status } = sampleRequest.processUpdates.sewing;
            const washStatus = sampleRequest.processUpdates.wash.status;

            if (sewing && status !== "COMPLETED") {
              return resolve({
                isErr: true,
                message: "Sewing process need to complete!",
              });
            } else if (
              wash &&
              (washStatus === "PENDING" || washStatus === "IN PROCESS")
            ) {
              return resolve({
                isErr: true,
                message: "Washing process need to complete or cancel!",
              });
            }
            return resolve({ isErr: false });
          }
        }
      } catch (error) {
        reject({ isErr: true, message: "something went wrong" });
      }
    });
  };

  //toggle update
  toggleChange = (name, value) => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.toggle[name] = value;
    this.setState([sampleRequest]);
  };

  printData = () => {
    this.sampleRequestMain();
    this.sampleFabricPrint();
    this.samplePrintTrim();
    // this.samplePrintWash()
  };

  samplePrintWash = () => {
    const sampleMain = { ...this.state.sampleMain };
    let washType =
      this.state.sampleRequest.wash &&
      this.state.sampleRequest.wash.washData &&
      this.state.sampleRequest.wash.washData.washType &&
      this.state.prefillInfo.WASH.WASHTYPE.find(
        (x) => x.value === this.state.sampleRequest.wash.washData.washType,
      ).label;

    sampleMain.washType = washType || "";

    this.setState({
      sampleMain,
    });
  };

  sampleRequestMain = () => {
    const sampleMain = {};
    const sampleRequest = { ...this.state.sampleRequest };
    setTimeout(() => {
      if (!!sampleRequest.originationOfRequest) {
        sampleMain.originationOfRequest =
          (document.getElementsByName("originationOfRequest")[0] &&
            document.getElementsByName("originationOfRequest")[0]
              .selectedOptions[0].innerHTML) ||
          undefined;
        sampleMain.originationOfRequest =
          (sampleMain.originationOfRequest !== "--select--" &&
            sampleMain.originationOfRequest) ||
          "";
      }
      sampleMain.styleRefNo = this.state.styleNoInfo[0].label;
      sampleMain.createdAt = this.state.createdAt || new Date();
      sampleMain.qr = sampleRequest.qr;
      sampleMain.buyerName = sampleRequest.magnumBuyerStyleName;
      sampleMain.assistantBuyer = sampleRequest.assistantBuyer;
      sampleMain.fabricTechnologist = sampleRequest.fabricTechnologist;
      sampleMain.garmentTechnology = sampleRequest.garmentTechnology;
      sampleMain.magnumTechnologist = sampleRequest.magnumTechnologist;
      sampleMain.requestNumber = sampleRequest.requestNumber;
      sampleMain.magnumStyleName = sampleRequest.magnumStyleName;
      sampleMain.customerRefNumber = sampleRequest.customerRefNumber;
      sampleMain.itemNumber = sampleRequest.itemNumber;
      sampleMain.blockRefNo = sampleRequest.blockRefNo;
      sampleMain.oldMagStyleNo = sampleRequest.oldMagStyleNo;
      sampleMain.refColNo = sampleRequest.refColNo;
      sampleMain.bNumber = sampleRequest.fabric.map((item) => item.bNumber);
      sampleMain.fabricName = sampleRequest.fabric.map(
        (item) => item.fabricName,
      );

      let washType =
        (document.getElementsByName("washType")[0] &&
          document.getElementsByName("washType")[0].selectedOptions[0]
            .innerHTML) ||
        undefined;
      sampleMain.washType = (washType !== "--select--" && washType) || "";

      if (!!sampleRequest.typeOfRequest) {
        sampleMain.typeOfRequest =
          document.getElementsByName(
            "typeOfRequest",
          )[0].selectedOptions[0].innerHTML;
        sampleMain.typeOfRequest =
          (sampleMain.typeOfRequest !== "--select--" &&
            sampleMain.typeOfRequest) ||
          "";
      }
      if (!!sampleRequest.sampleType) {
        sampleMain.sampleType =
          document.getElementsByName(
            "sampleType",
          )[0].selectedOptions[0].innerHTML;
      }

      if (!!sampleRequest.customer && !!sampleRequest.customerDepartmentId) {
        sampleMain.customer =
          document.getElementsByName(
            "customer",
          )[0].selectedOptions[0].innerHTML;

        // sampleMain.departmentName = this.state.customerList.find(
        //   (data, index) =>
        //     data.departmentId === sampleRequest.customerDepartmentId
        // ).departmentName;
      }

      this.setState({
        sampleMain,
      });
      this.sampleFabricPrint();
    }, 500);
  };

  sampleFabricPrint = () => {
    const sampleFabric = {};

    let sampleArray = [];
    let fabricArray = [];

    setTimeout(() => {
      if (
        this.state.sampleRequest &&
        this.state.sampleRequest.sample &&
        this.state.sampleRequest.sample.data.length > 0
      ) {
        this.state.sampleRequest.sample.data.map((data, index) => {
          let sample = {};
          sample.size = data.size;
          sample.quantity = data.quantity;

          sampleArray.push(sample);
        });

        sampleFabric.sampleComments = this.state.sampleRequest.sample.comments;
      }

      if (
        this.state.sampleRequest &&
        this.state.sampleRequest.fabric &&
        this.state.sampleRequest.fabric.length > 0
      ) {
        this.state.sampleRequest.fabric.map((fabricData, index) => {
          let fabric = {};
          if (!!fabricData.fabricNumber) {
            fabric.fabricNumber = fabricData.fabricList[0].label;
          }

          if (!!fabricData.fabricPosition) {
            fabric.fabricPosition =
              this.state.prefillInfo.SAMPLEREQUEST.POSITION &&
              this.state.prefillInfo.SAMPLEREQUEST.POSITION.length &&
              this.state.prefillInfo.SAMPLEREQUEST.POSITION.find(
                (data, index) => data.value === fabricData.fabricPosition,
              ).label;
          }

          if (!!fabricData.fabricOrigination) {
            fabric.fabricOrigination =
              this.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION &&
              this.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION.length &&
              this.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION.find(
                (data, index) => data.value === fabricData.fabricOrigination,
              ).label;
          }

          fabric.classificationOfFabric = fabricData.classificationOfFabric;
          fabric.quality = fabricData.quality;
          fabric.countAndConstruction = fabricData.countAndConstruction;
          fabric.check = fabricData.quality;
          fabricArray.push(fabric);
        });
      }

      sampleFabric.fabricArray = [...fabricArray];
      sampleFabric.sampleArray = [...sampleArray];
      setTimeout(
        () =>
          this.setState({
            sampleMain: {
              ...this.state.sampleMain,
              sampleFabric,
            },
          }),
        500,
      );
    }, 500);
  };

  samplePrintTrim = () => {
    let sampleTrim = {
      trimArray: [],
    };

    setTimeout(() => {
      if (
        this.state.sampleRequest.trim &&
        this.state.sampleRequest.trim.row1 &&
        this.state.sampleRequest.trim.row1.length > 0
      ) {
        this.state.sampleRequest.trim.row1.map((trims, index) => {
          let trimObject = {};

          if (
            this.state.prefillInfo &&
            this.state.prefillInfo.TRIM &&
            this.state.prefillInfo.TRIM.TRIMCATEGORY
          ) {
            trimObject.trimCategory =
              this.state.prefillInfo.TRIM.TRIMCATEGORY.map((data, index) => {
                if (data.value === trims.trimCategory) {
                  return data.label;
                }
              }).filter(Boolean)[0];
          }
          if (trims.trimNumber && trims.trimList) {
            trimObject.trimNumber = trims.trimList
              .map((data, index) => {
                if (data.value === trims.trimNumber) {
                  return data.label;
                }
              })
              .filter(Boolean)[0];
          }
          trimObject.description = trims.description;
          trimObject.quality = trims.quality;
          trimObject.sizeNumber = trims.sizeNumber;
          trimObject.size = trims.size;
          sampleTrim.trimArray.push(trimObject);
        });
      }

      setTimeout(
        () =>
          this.setState({
            sampleMain: {
              ...this.state.sampleMain,
              sampleTrim,
            },
          }),
        500,
      );
    }, 500);
  };

  openPrint = (val) => {
    let sampleMain = JSON.parse(JSON.stringify(this.state.sampleMain));

    this.setState(
      {
        sampleMain,
        printLoading: true,
      },
      () => {
        // Get the div to print by its ID
        const divToPrint = document.getElementById(val);
        const newWin = window.open("", "mywindow");

        if (newWin) {
          newWin.document.write(`
            <html>
              <head>
                <title>Print Preview</title>
              </head>
              <body>
                ${divToPrint.outerHTML}
              </body>
            </html>
          `);

          newWin.document.close(); // Finish writing to the new window

          // Now wait until the new window finishes loading
          newWin.onload = function () {
            newWin.focus(); // Focus the window (sometimes needed)
            newWin.print(); // Now safely print
            newWin.close(); // Optionally close after print
          };
        } else {
          console.error("Failed to open the print window");
        }
      },
    );
  };
  confirmDuplicate = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className=" p-5 text-center">
            <h3>Do you want to create a duplicate Sample Request sheet?</h3>
            <p>
              If yes, Kindly don't forget to change/choose the new Source of
              Request and the Sample Type.{" "}
              <strong>
                (marked with{" "}
                <span className="text-danger madatory-asterisk">*</span>)
              </strong>
            </p>
            {/* <p>Are you sure you would like to Duplicate?</p> */}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={onClose}
            >
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={() => {
                this.createDuplicate();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      closeOnClickOutside: true,
    });
  };
  createDuplicate = () => {
    if (this.state._id !== "") {
      SampleServices.getSampleQr()
        .then((response) => {
          if (response.status === 200) {
            let sampleRequest = { ...this.state.sampleRequest };
            sampleRequest.qr = response.text.data.qr;
            sampleRequest.requestNumber = response.text.data.requestNumber;
            sampleRequest.typeOfRequest = "";
            sampleRequest.sampleType = null;
            sampleRequest.orderDate = new Date();
            sampleRequest.createdAt = sampleRequest.updatedAt = undefined;
            this.setState({
              sampleRequest: { ...sampleRequest, ...this.state.duplicateData },
              action: "add",
              _id: "",
              // isLoading: false
            });
            this.props.getalertMessage(
              "success",
              "Duplicate Success! Please select Source of Request and Sample Type",
              5000,
            );
          }
          response.status === 401 && this.props.unauthorisedFunc();
        })
        .catch((err) => {
          this.props.getalertMessage("error");
        });
    } else {
      this.props.getalertMessage("error", "Need to Create");
    }
  };

  getTrimRefNo = (trimCategory, value, index) => {
    SampleServices.getTrimNumber(trimCategory, value)
      .then(async (response) => {
        const sampleRequest = { ...this.state.sampleRequest };
        sampleRequest.trim.row1[index].trimList = response.text.data;
        this.setState({
          // trimNumberList: response.text.data
          sampleRequest,
        });
      })
      .catch((error) => alert(error.toString()));
  };

  getTrimRefNoSewing = (trimCategory, value, index) => {
    SampleServices.getTrimNumber(trimCategory, value)
      .then(async (response) => {
        const sampleRequest = { ...this.state.sampleRequest };

        sampleRequest.sewing.trimData[index].trimList = response.text.data;
        this.setState({
          // trimNumberList: response.text.data
          sampleRequest,
        });
      })
      .catch((error) => alert(error.toString()));
  };

  getFabricNumber = (value, index) => {
    // alert(1)
    DevelopmentServices.getFabricNumber(value)
      .then((response) => {
        if (response.status == 200) {
          // this.setState({ fabricList: response.text.data })
          let sampleRequest = { ...this.state.sampleRequest };
          if (sampleRequest.fabric.length) {
            sampleRequest.fabric[index].fabricList = response.text.data;
            this.setState({ sampleRequest });
          }
        }
      })
      .catch((error) => {});
  };

  setDuration = (days, duration) => {
    const diffDays = days ? moment().diff(new Date(days), "days") : 0;
    return diffDays ? 0 : duration || 0;
  };

  render() {
    const { sampleRequest } = this.state;
    //console.log(this.state.sampleRequest, "sampleRequest");
    //console.log(this.state.measurementChartData,"mea")
   
    const { rights } = this.props;

    const { toggle } = this.state.sampleRequest;

    if (this.state.prefillInfo.SYSTEMSAMPLEREQUEST.DURATION) {
      var { DISPATCH, FABRIC, PATTERNS, TRIM } =
        this.state.prefillInfo.SYSTEMSAMPLEREQUEST.DURATION;
    }

    if (Object.keys(this.state.prefillInfo).length > 0) {
      return (
        <div className="right-section remove-scroll-for-right">
          <div className="row nopadding">
            {this.state.isLoading && <Loading />}
            <div className="col-md-12 nopadding">
              <LeftSection
                // sampleRequest={sampleRequest}
                getCustomerDepartmentName={this.getCustomerDepartmentName}
                action={this.state.action}
                history={this.props.history}
                sampleRequest={sampleRequest}
                magnumStyleId={this.state.sampleRequest.magnumStyleId}
                SAMPLETYPE={
                  Object.keys(this.state.prefillInfo.SAMPLEREQUEST).length > 0
                    ? this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE
                    : []
                }
                styleNoInfo={this.state.styleNoInfo}
                getMagnumStyleNo={(value) => this.getMagnumStyleNo(value)}
                getStyleReferenceInfo={this.getStyleReferenceInfo}
                updateSampleRequest={this.updateSampleRequest}
                updateCustomerDept={this.updateCustomerDept}
                saveSampleRequest={this.saveSampleRequest}
                disabled={this.state.disabled}
              />
              {/* RIGHT SECTION START */}
              <div
                id="right-section"
                className="right-content-section overflow-scroll bg-white"
              >
                <Audit _id={this.state._id} />
                <span
                  className="btn-green-icon mr-3 pull-right"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    this.setState({ isLoading: true });
                    setTimeout(() => {
                      this.printData();
                      this.setState({ isLoading: false });
                      setTimeout(() => this.openPrint("printSample"), 5000);
                    }, 2000);
                  }}
                >
                  <img src={printer} />
                </span>
                <PageHeader
                  header="SAMPLE REQUEST"
                  history={this.props.history}
                />
                <SampleMain
                  sampleRequest={sampleRequest}
                  updateSampleRequest={this.updateSampleRequest}
                  SAMPLEREQUEST={this.state.prefillInfo.SAMPLEREQUEST}
                  createSample={this.createSample}
                  disabled={this.state.disabled}
                  orderDate={this.state.sampleRequest.orderDate}
                  confirmDuplicate={this.confirmDuplicate}
                  rights={rights}
                />
                <SampleModuleSelect
                  selectedModule={(data) => this.handleselectedType(data)}
                  selected={this.state.sampleRequest.selectedType}
                  toggle={this.state.sampleRequest.toggle}
                  rights={rights}
                  action={this.state.action}
                  toggleChange={this.toggleChange}
                  disabled={this.state.disabled}
                />

                <div class="col-md-12 text-center">
                  {!this.state.disabled && (
                    <Button
                      buttonName={"SAVE"}
                      buttonType={"save"}
                      onClick={this.createSample}
                    />
                  )}
                </div>

                {/* Tab for process */}
                <div id="exTab2" className="col-md-12">
                  <ul className="nav nav-tabs">
                    <li className="active">
                      <a href="#1" data-toggle="tab">
                        Manage Process
                      </a>
                    </li>
                    <li>
                      <a href="#2" data-toggle="tab">
                        Process updates
                      </a>
                    </li>
                  </ul>
                  {/* Start of tab content */}
                  <div className="tab-content">
                    {/* Start of Manage process tab */}
                    <div className="tab-pane active" id="1">
                      <div
                        className="col-md-12 nopadding tab-pane active"
                        id="manage-process"
                      >
                        {((rights.sample.web.view &&
                          this.state.action === "view") ||
                          (rights.sample.web.create &&
                            this.state.action === "add") ||
                          (rights.sample.web.edit &&
                            this.state.action === "edit")) &&
                          this.state.selected !== "costingRequest" &&
                          toggle.sample && (
                            <Fragment>
                              <SampleModule
                                _id={this.state._id}
                                sample={this.state.sampleRequest.sample}
                                sampleProcess={
                                  this.state.sampleRequest.processUpdates.sample
                                }
                                SAMPLEREQUEST={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                }
                                sizeList={this.state.sizeList}
                                STATUS={this.state.prefillInfo.STATUS}
                                updateModulesMain={this.updateModulesMain}
                                createSampleModule={this.createSampleModule}
                                completeSampleModule={this.completeSampleModule}
                                getSample={this.updateSampleModule}
                                sampleRights={rights.sample}
                                addSize={this.addSize}
                                removeSize={this.removeSize}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.sample.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.garmentTech.web.view &&
                          this.state.action === "view") ||
                          (rights.garmentTech.web.create &&
                            this.state.action === "add") ||
                          (rights.garmentTech.web.edit &&
                            this.state.action === "edit")) &&
                          this.state.selected !== "costingRequest" &&
                          toggle.garmentTechnologist && (
                            <Fragment>
                              <GarmentTechModule
                                _id={this.state._id}
                                garmentTechnologist={
                                  this.state.sampleRequest.garmentTechnologist
                                }
                                garmentProcess={
                                  this.state.sampleRequest.processUpdates
                                    .garmentTechnologist
                                }
                                updateModulesMain={this.updateModulesMain}
                                printGarment={this.printGarment}
                                STATUS={this.state.prefillInfo.STATUS}
                                updateGarment={this.updateGarment}
                                updateGarmentForm={this.updateGarmentForm}
                                addGarmentForm={this.addGarmentForm}
                                removeGarmentForm={this.removeGarmentForm}
                                createGarment={this.createGarment}
                                completeGarment={this.completeGarment}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.garmentTech.web}
                                editorDraft={this.onEditorStateChange}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}

                        {((rights.cad.web.view &&
                          this.state.action === "view") ||
                          (rights.cad.web.create &&
                            this.state.action === "add") ||
                          (rights.cad.web.edit &&
                            this.state.action === "edit")) &&
                          this.state.selected !== "costingRequest" &&
                          toggle.cad && (
                            <Fragment>
                              <CadModule
                                cadPreFill={this.state.cadPreFill}
                                _id={this.state._id}
                                cad={this.state.sampleRequest.cad}
                                cadProcess={
                                  this.state.sampleRequest.processUpdates.cad
                                }
                                updateModulesMain={this.updateModulesMain}
                                cadUpdate={this.cadUpdate}
                                getCad={this.updateCad}
                                saveCAD={this.saveCAD}
                                completeCAD={this.completeCAD}
                                updateCadValues={this.updateCadValues}
                                changeCADRefNum={this.changeCADRefNum}
                                CAD={this.state.prefillInfo.CAD}
                                STATUS={this.state.prefillInfo.STATUS}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.cad.web}
                                history={this.props.history}
                                action={this.state.action}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.fabric.web.view &&
                          this.state.action === "view") ||
                          (rights.fabric.web.create &&
                            this.state.action === "add") ||
                          (rights.fabric.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.fabric && (
                            <Fragment>
                              <FabricModule
                                getFabricNumber={this.getFabricNumber}
                                fabricList={this.state.fabricList}
                                _id={this.state._id}
                                updateFabricName={this.updateFabricName}
                                // durationFabric={
                                //   this.setDuration(this.state.sampleRequest.processUpdates.fabric.ETA, FABRIC)
                                // }
                                fabric={this.state.sampleRequest.fabric}
                                fabricRadio={
                                  this.state.sampleRequest.fabricRadio
                                }
                                fabricProcess={
                                  this.state.sampleRequest.processUpdates.fabric
                                }
                                updateModulesMain={this.updateModulesMain}
                                SAMPLEREQUEST={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                }
                                FABRIC={this.state.prefillInfo.FABRIC}
                                STATUS={this.state.prefillInfo.STATUS}
                                createFabric={this.createFabric}
                                updateFabric={this.updateFabric}
                                clearDummyFabric={this.clearDummyFabric}
                                fabricComments={
                                  this.state.sampleRequest.fabricComments
                                }
                                updateSampleRequest={this.updateSampleRequest}
                                completeFabric={this.completeFabric}
                                addFabric={this.addFabric}
                                removeFabric={this.removeFabric}
                                getFabricInfo={this.getFabricInfo}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.fabric.web}
                                history={this.props.history}
                                printFabric={this.printFabric}
                                getalertMessage={this.props.getalertMessage}
                                action={this.state.action}
                                parentstate={this.state}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}

                        <div className="clearfix" />
                        {((rights.trim.web.view &&
                          this.state.action === "view") ||
                          (rights.trim.web.create &&
                            this.state.action === "add") ||
                          (rights.trim.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.trim && (
                            <Fragment>
                              <TrimModule
                                getTrimRefNo={this.getTrimRefNo}
                                getalertMessage={this.props.getalertMessage}
                                _id={this.state._id}
                                // durationTrim={this.setDuration(this.state.sampleRequest.processUpdates.trim.ETA, TRIM)}
                                trim={this.state.sampleRequest.trim}
                                trimRadio={this.state.sampleRequest.trimRadio}
                                trimProcess={
                                  this.state.sampleRequest.processUpdates.trim
                                }
                                styleNoInfo={this.state.styleNoInfo}
                                updateSampleRequest={this.updateSampleRequest}
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                TRIM={this.state.prefillInfo.TRIM}
                                TRIMPLACEMENT={
                                  this.state.prefillInfo.TRIMPLACEMENT
                                }
                                updateTrim={this.updateTrim}
                                updateTrimRow1={this.updateTrimRow1}
                                updateTrimRow2={this.updateTrimRow2}
                                getTrimInfo={this.getTrimInfo}
                                getTrimInfoRow2={this.getTrimInfoRow2}
                                removeTrim={this.removeTrim}
                                addTrim={this.addTrim}
                                createTrim={this.createTrim}
                                completeTrim={this.completeTrim}
                                assignedToList={this.state.assignedToList}
                                trimNumberList={this.state.trimNumberList}
                                disabled={this.state.disabled}
                                permissions={rights.trim.web}
                                history={this.props.history}
                                action={this.state.action}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        <Fragment>
                          {((rights.pattern.web.view &&
                            this.state.action === "view") ||
                            (rights.pattern.web.create &&
                              this.state.action === "add") ||
                            (rights.pattern.web.edit &&
                              this.state.action === "edit")) &&
                            toggle.pattern && (
                              <PatternModule
                                _id={this.state._id}
                                // durationPatterns={this.setDuration(this.state.sampleRequest.processUpdates
                                //   .pattern.ETA, PATTERNS)}
                                pattern={this.state.sampleRequest.pattern}
                                patternProcess={
                                  this.state.sampleRequest.processUpdates
                                    .pattern
                                }
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                PATTERNTYPE={this.state.prefillInfo.PATTERNTYPE}
                                assignedToList={
                                  this.state.prefillInfo.PATTERNMASTER
                                }
                                updatePatternCheck={this.updatePatternCheck}
                                updatePattern={this.updatePattern}
                                updatePatternLog={this.updatePatternLog}
                                addPatternLog={this.addPatternLog}
                                createPattern={this.createPattern}
                                completePattern={this.completePattern}
                                removePatternLog={this.removePatternLog}
                                disabled={this.state.disabled}
                                permissions={rights.pattern.web}
                                getCustomerDepartmentName={
                                  this.getCustomerDepartmentName
                                }
                                magnumStyleId={
                                  this.state.sampleRequest.magnumStyleId
                                }
                                SAMPLETYPE={
                                  Object.keys(
                                    this.state.prefillInfo.SAMPLEREQUEST,
                                  ).length > 0
                                    ? this.state.prefillInfo.SAMPLEREQUEST
                                        .SAMPLETYPE
                                    : []
                                }
                                styleNoInfo={this.state.styleNoInfo}
                                getMagnumStyleNo={(value) =>
                                  this.getMagnumStyleNo(value)
                                }
                                getStyleReferenceInfo={
                                  this.getStyleReferenceInfo
                                }
                                customer={this.state.sampleRequest.customer}
                                customerDepartmentId={
                                  this.state.sampleRequest.customerDepartmentId
                                }
                                type={this.state.sampleRequest.typeOfRequest}
                              />
                            )}
                          <div className="clearfix" />
                          <hr />
                        </Fragment>
                        {((rights.cutting.web.view &&
                          this.state.action === "view") ||
                          (rights.cutting.web.create &&
                            this.state.action === "add") ||
                          (rights.cutting.web.edit &&
                            this.state.action === "edit")) &&
                          this.state.selected !== "costingRequest" &&
                          toggle.cutting && (
                            <Fragment>
                              <CuttingModule
                                _id={this.state._id}
                                cutting={this.state.sampleRequest.cutting}
                                sample={this.state.sampleRequest.sample}
                                cuttingProcess={
                                  this.state.sampleRequest.processUpdates
                                    .cutting
                                }
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                CUTTINGTYPE={this.state.prefillInfo.CUTTINGTYPE}
                                assignedToList={
                                  this.state.prefillInfo.CUTTINGMASTER
                                }
                                updateCutting={this.updateCutting}
                                updateCuttingLog={this.updateCuttingLog}
                                updateCuttingCheck={this.updateCuttingCheck}
                                createCutting={this.createCutting}
                                addCuttingLog={this.addCuttingLog}
                                removeCuttingLog={this.removeCuttingLog}
                                completeCutting={this.completeCutting}
                                disabled={this.state.disabled}
                                permissions={rights.cutting.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.sewing.web.view &&
                          this.state.action === "view") ||
                          (rights.sewing.web.create &&
                            this.state.action === "add") ||
                          (rights.sewing.web.edit &&
                            this.state.action === "edit")) &&
                          this.state.selected !== "costingRequest" &&
                          toggle.sewing && (
                            <Fragment>
                              <SewingModule
                                _id={this.state._id}
                                sewing={this.state.sampleRequest.sewing}
                                sample={this.state.sampleRequest.sample}
                                sewingProcess={
                                  this.state.sampleRequest.processUpdates.sewing
                                }
                                tailorName={
                                  this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                }
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                SEWINGTYPE={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                    .SEWINGTYPE
                                }
                                PLACEOFSEWING={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                    .PLACEOFSEWING
                                }
                                TRIM={this.state.prefillInfo.TRIM}
                                TRIMPLACEMENT={
                                  this.state.prefillInfo.TRIMPLACEMENT
                                }
                                trimNumberList={this.state.trimNumberList}
                                updateSewingTrimData={this.updateSewingTrimData}
                                getTrimInfoSewTrimData={
                                  this.getTrimInfoSewTrimData
                                }
                                updateSewing={this.updateSewing}
                                updateSewing1={this.updateSewing1}
                                addSewing={this.addSewing}
                                removeSewing={this.removeSewing}
                                updateSewingLog={this.updateSewingLog}
                                updateSewingCheck={this.updateSewingCheck}
                                createSewing={this.createSewing}
                                addSewingLog={this.addSewingLog}
                                removeSewingLog={this.removeSewingLog}
                                completeSewing={this.completeSewing}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.sewing.web}
                                smockingShirringaddTrim={
                                  this.smockingShirringaddTrim
                                }
                                smockingShirringremoveTrim={
                                  this.smockingShirringremoveTrim
                                }
                                getTrimRefNoSewing={this.getTrimRefNoSewing}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}

                        {((rights.embellishment.web.view &&
                          this.state.action === "view") ||
                          (rights.embellishment.web.create &&
                            this.state.action === "add") ||
                          (rights.embellishment.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.embellishment && (
                            <Fragment>
                              <EmbellishmentModule
                                _id={this.state._id}
                                embellishment={
                                  this.state.sampleRequest.embellishment
                                }
                                embellishmentComments={
                                  this.state.sampleRequest.embellishmentComments
                                }
                                embellishmentProcess={
                                  this.state.sampleRequest.processUpdates
                                    .embellishment
                                }
                                updateModulesMain={this.updateModulesMain}
                                updateSampleRequest={this.updateSampleRequest}
                                addEmb={this.addEmb}
                                removeEmb={this.removeEmb}
                                STATUS={this.state.prefillInfo.STATUS}
                                updateEmbellishment={this.updateEmbellishment}
                                createEmbellishment={this.createEmbellishment}
                                completeEmbellishment={
                                  this.completeEmbellishment
                                }
                                TYPE={this.state.prefillInfo.SAMPLEREQUEST.TYPE}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.embellishment.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.embroidery.web.view &&
                          this.state.action === "view") ||
                          (rights.embroidery.web.create &&
                            this.state.action === "add") ||
                          (rights.embroidery.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.embroidery && (
                            <Fragment>
                              <EmbroideryModule
                                _id={this.state._id}
                                embroidery={this.state.sampleRequest.embroidery}
                                embroideryData={
                                  this.state.sampleRequest.embroidery
                                    .embroideryData
                                }
                                embroideryProcess={
                                  this.state.sampleRequest.processUpdates
                                    .embroidery
                                }
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                BACKINGTYPE={
                                  this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                    .BACKINGTYPE
                                }
                                PLACEMENT={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                    .PLACEMENT_EMB
                                }
                                EMBFORM={
                                  this.state.prefillInfo.SAMPLEREQUEST.EMBFORM
                                }
                                EMBPLACEMENT={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                    .EMBPLACEMENT
                                }
                                NOOFCOLORS={
                                  this.state.prefillInfo.SAMPLEREQUEST
                                    .NOOFCOLORS
                                }
                                FRAMES={
                                  this.state.prefillInfo.SAMPLEREQUEST.FRAMES
                                }
                                LEFTVALUES={
                                  this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                    .LEFTVALUES
                                }
                                PRICE1000STICHES={
                                  this.state.prefillInfo.SYSTEMSAMPLEREQUEST[
                                    "PRICE&1000STICHES"
                                  ]
                                }
                                updateEmbroidery={this.updateEmbroidery}
                                updateEmbroideryBackingData={
                                  this.updateEmbroideryBackingData
                                }
                                updateEmbroideryData={this.updateEmbroideryData}
                                addEmbroideryData={this.addEmbroideryData}
                                changeBackingArray={this.changeBackingArray}
                                removeEmbroideryData={this.removeEmbroideryData}
                                moveToRight={this.moveToRight}
                                moveToLeft={this.moveToLeft}
                                moveToBottom={this.moveToBottom}
                                moveToUp={this.moveToUp}
                                saveEmbroidery={this.saveEmbroidery}
                                completeEmbroidery={this.completeEmbroidery}
                                getRefImages={this.getRefImages}
                                assignedToList={this.state.assignedToList}
                                widthList={this.state.widthList}
                                disabled={this.state.disabled}
                                permissions={rights.embroidery.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.wash.web.view &&
                          this.state.action === "view") ||
                          (rights.wash.web.create &&
                            this.state.action === "add") ||
                          (rights.wash.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.wash && (
                            <Fragment>
                              <WashModule
                                _id={this.state._id}
                                wash={this.state.sampleRequest.wash}
                                washProcess={
                                  this.state.sampleRequest.processUpdates.wash
                                }
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                WASHTYPE={this.state.prefillInfo.WASH.WASHTYPE}
                                WASHFORM={this.state.prefillInfo.WASH.WASHFORM}
                                LU={this.state.prefillInfo.WASH.LAUNDRYUNIT}
                                NOOFMOCKS={
                                  this.state.prefillInfo.WASH.NOOFMOCKS
                                }
                                PRICEPERKG={
                                  this.state.prefillInfo.WASH.PRICEPERKG
                                }
                                changeWashData={this.changeWashData}
                                updateWash={this.updateWash}
                                updateWash1={this.updateWash1}
                                createWash={this.createWash}
                                getRefImages={this.getRefImages}
                                completeWash={this.completeWash}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.wash.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.dispatch.web.view &&
                          this.state.action === "view") ||
                          (rights.dispatch.web.create &&
                            this.state.action === "add") ||
                          (rights.dispatch.web.edit &&
                            this.state.action === "edit")) &&
                          this.state.selected !== "costingRequest" &&
                          toggle.dispatch && (
                            <Fragment>
                              <DispatchModule
                                _id={this.state._id}
                                // durationDispatch={
                                //   this.setDuration(this.state.sampleRequest.processUpdates.dispatch.ETA, DISPATCH)
                                // }
                                dispatch={this.state.sampleRequest.dispatch}
                                dispatchProcess={
                                  this.state.sampleRequest.processUpdates
                                    .dispatch
                                }
                                updateModulesMain={this.updateModulesMain}
                                udpateDispatch={this.updateDispatch}
                                udpateDispatchValues={this.udpateDispatchValues}
                                addDispatchData={this.addDispatchData}
                                removeDispatchData={this.removeDispatchData}
                                createDispatch={this.createDispatch}
                                completeDispatch={this.completeDispatch}
                                STATUS={this.state.prefillInfo.STATUS}
                                SIZELIST={this.state.sizeList}
                                COURIER={
                                  this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                    .COURIER
                                }
                                LOCATION={
                                  this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                    .LOCATION
                                }
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.dispatch.web}
                                customer={this.state.sampleRequest.customer}
                                customerDepartmentId={
                                  this.state.sampleRequest.customerDepartmentId
                                }
                                type={this.state.sampleRequest.typeOfRequest}
                                magnumStyleId={
                                  this.state.sampleRequest.magnumStyleId
                                }
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.QC.web.view &&
                          this.state.action === "view") ||
                          (rights.QC.web.create &&
                            this.state.action === "add") ||
                          (rights.QC.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.qc && (
                            <Fragment>
                              <QcModule
                                _id={this.state._id}
                                qc={this.state.sampleRequest.qc}
                                qcProcess={
                                  this.state.sampleRequest.processUpdates.qc
                                }
                                updateModulesMain={this.updateModulesMain}
                                updateQc={this.updateQc}
                                createQC={this.createQC}
                                completeQC={this.completeQC}
                                STATUS={this.state.prefillInfo.STATUS}
                                getRefImages={this.getRefImages}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.QC.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}

                        {((rights.marker.web.view &&
                          this.state.action === "view") ||
                          (rights.marker.web.create &&
                            this.state.action === "add") ||
                          (rights.marker.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.marker && (
                            <Fragment>
                              <MarkerModule
                                _id={this.state._id}
                                marker={this.state.sampleRequest.marker}
                                markerProcess={
                                  this.state.sampleRequest.processUpdates.marker
                                }
                                updateModulesMain={this.updateModulesMain}
                                updateMarker={this.updateMarker}
                                createMarker={this.createMarker}
                                completeMarker={this.completeMarker}
                                getRefImages={this.getRefImages}
                                STATUS={this.state.prefillInfo.STATUS}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.marker.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}

                        {((rights.costing.web.view &&
                          this.state.action === "view") ||
                          (rights.costing.web.create &&
                            this.state.action === "add") ||
                          (rights.costing.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.costing && (
                            <Fragment>
                              <CostingModule
                                _id={this.state._id}
                                costingComments={
                                  this.state.sampleRequest.costingComments
                                }
                                costingProcess={
                                  this.state.sampleRequest.processUpdates
                                    .costing
                                }
                                updateModulesMain={this.updateModulesMain}
                                updateCosting={this.updateSampleRequest}
                                createCosting={this.createCosting}
                                completeCosting={this.completeCosting}
                                createCostingPage={this.createCostingPage}
                                viewCostingPage={this.viewCostingPage}
                                STATUS={this.state.prefillInfo.STATUS}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.costing.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                        {((rights.signoff.web.view &&
                          this.state.action === "view") ||
                          (rights.signoff.web.create &&
                            this.state.action === "add") ||
                          (rights.signoff.web.edit &&
                            this.state.action === "edit")) &&
                          toggle.signOff && (
                            <Fragment>
                              <SignOffModule
                                _id={this.state._id}
                                signOffComments={
                                  this.state.sampleRequest.signOffComments
                                }
                                signOffProcess={
                                  this.state.sampleRequest.processUpdates
                                    .signOff
                                }
                                updateModulesMain={this.updateModulesMain}
                                STATUS={this.state.prefillInfo.STATUS}
                                updateSignOff={this.updateSampleRequest}
                                createSignOff={this.createSignOff}
                                completeSignoff={this.completeSignoff}
                                assignedToList={this.state.assignedToList}
                                disabled={this.state.disabled}
                                permissions={rights.signoff.web}
                              />
                              <div className="clearfix" />
                              <hr />
                            </Fragment>
                          )}
                      </div>
                      <ScrollMenu
                        toggleData={sampleRequest.toggle}
                        scrollToModule={this.scrollToModule}
                        selectedQequest={
                          this.state.selected !== "costingRequest"
                        }
                        rights={rights}
                      />
                    </div>
                    {/* End of manage process tab      */}
                    {/* Start of process updates tab */}
                    <div className="tab-pane" id="2">
                      <ProcessUpdate
                        _id={this.state._id}
                        toggle={this.state.sampleRequest.toggle}
                        STATUS={this.state.prefillInfo.STATUS}
                        processUpdates={this.state.sampleRequest.processUpdates}
                        ProcessUpdates={this.ProcessUpdates}
                        updateProcessUpdate={this.updateProcessUpdate}
                        assignedTo={this.state.assignedTo}
                        assignedToList={this.state.assignedToList}
                        disabled={this.state.disabled}
                        completeAllHandler={this.completeAllHandler}
                        permissions={rights}
                        action={this.state.action}
                      />
                    </div>
                    {/* End of process updates tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* RIGHT SECTION END */}
          <div id="printSample" className="d-none">
            {this.state.printLoading && (
              <PrintSample
                toggle={this.state.sampleRequest.toggle}
                sampleMain={this.state.sampleMain}
                bNo={this.state.sampleRequest.test1}
              />
            )}
          </div>
          <div id="print-garment" className="d-none">
            {this.state.printGarmentLoading && (
              <PrintGarmentTech
                printGarmentTech={this.state.printGarmentTech}
              />
            )}
          </div>
          {/* <GarmentTech garmentTechnologist={sampleRequest.garmentTechnologist} updateGarmentForm={this.updateGarmentForm} /> */}
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    rights: state.main.rights.sampleRequest,
    userDetails: state.main,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators({
//       "getRights": getRights
//   }, dispatch)
// }

export default connect(mapStateToProps, null)(Sample);

// export default Sample;



// WEBPACK FOOTER //
// ./src/pages/Sample/page.js